import { animate, animateChild, group, query, stagger, state, style, transition, trigger } from '@angular/animations';
import { HttpClient } from '@angular/common/http';
import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, DoCheck, ElementRef, HostListener, Inject, Input, OnDestroy, OnInit, QueryList, Renderer2, ViewChild, ViewChildren } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { FileTransfer } from '@awesome-cordova-plugins/file-transfer/ngx';
import { File } from '@awesome-cordova-plugins/file/ngx';
import { Keyboard } from '@awesome-cordova-plugins/keyboard/ngx';
import { AlertController, AlertInput, IonFab, ModalController, NavController, Platform } from '@ionic/angular';
import { expandOnEnterAnimation, fadeInLeftAnimation, fadeInRightAnimation, slideInDownAnimation, slideInUpAnimation } from 'angular-animations';
import mixpanel from 'mixpanel-browser';
import * as moment from 'moment';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { MicroActionChatbotV1Component } from 'src/app/micro-action-chatbot-v1/micro-action-chatbot-v1.component';
import { MicroActionStateService } from 'src/app/micro-action-chatbot-v1/micro-action-state.service';
import { AlertIamInComponent } from 'src/app/alert-iam-in/alert-iam-in.component';
import { AlertRatingRoutineComponent } from 'src/app/alert-rating-routine/alert-rating-routine.component';
import { AlertRoutineAnimComponent } from 'src/app/alert-routine-anim/alert-routine-anim.component';
import { AlertWebCalendarComponent } from 'src/app/alert-web-calendar/alert-web-calendar.component';
import { AlertWebactionCalendarComponent } from 'src/app/alert-webaction-calendar/alert-webaction-calendar.component';
import { AppConstantsService } from 'src/app/app-constants.service';
import { browserRefresh } from 'src/app/app.component';
import { AppState } from 'src/app/app.service';
import { CalendarService } from 'src/app/calendar.service';
import { Client } from 'src/app/client/client.model';
import { CloseoutSurveyWelcomeComponent } from 'src/app/closeout-survey/closeout-survey-welcome.component';
import { CloseoutSurveyComponent } from 'src/app/closeout-survey/closeout-survey.component';
import { CurrentPathRegistration, UtilityService } from 'src/app/common-services/utility.service';
import { CompletedReviewModalComponent } from 'src/app/completed-review-modal/completed-review-modal.component';
import { CordovaService } from 'src/app/cordova.service';
import { RoutineService } from 'src/app/daily-content-v2/routine.service';
import { DailyStepsService } from 'src/app/daily-steps/daily-steps.service';
import { DocumentV2Component } from 'src/app/document-v2/document-v2.component';
import { Document } from 'src/app/document/document.model';
import { FullScreenAudioComponent } from 'src/app/full-screen-audio/full-screen-audio.component';
import { FullScreenVideoComponent } from 'src/app/full-screen-video/full-screen-video.component';
import { HabitListItem } from 'src/app/habit-list-modal/habit-list-modal.model';
import { Habit } from 'src/app/habit/habit.model';
import { HabitService } from 'src/app/habit/habit.service';
import { I18n } from 'src/app/i18n.service';
import { InoutScreen } from 'src/app/inout-screen/inout-screen.model';
import { LinearScaleComponent } from 'src/app/linear-scale/linear-scale.component';
import { MyCommitmentsComponent } from 'src/app/my-commitments/my-commitments.component';
import { FullScreenDocumentComponent } from 'src/app/my-library/full-screen-document.component';
import { Reflection } from 'src/app/my-library/full-screen-reflection/reflection.model';
import { Library } from 'src/app/my-library/library.model';
import { LibraryService } from 'src/app/my-library/library.service';
import { OnboardingLearningNotificationComponent } from 'src/app/onboarding-learning-notification/onboarding-learning-notification.component';
import { HomeV5Service } from 'src/app/pages/home-v5/home-v5.service';
import { Poll } from 'src/app/poll/poll.model';
import { PollService } from 'src/app/poll/poll.service';
import { Question } from 'src/app/question/question.model';
import { RoutineCalendarComponent } from 'src/app/routine-v2/routine-calendar/routine-calendar/routine-calendar.component';
import { RoutineInfo } from 'src/app/routine-v2/routine-info.model';
import { RoutineV2Service } from 'src/app/routine-v2/routine-v2.service';
import { SessionService } from 'src/app/session/session.service';
import { SpinnerService } from 'src/app/spinner.service';
import { ThemeService } from 'src/app/theme/theme.service';
import { TodoListModel } from 'src/app/to-do-list/todo-list.model';
import { ToasterService } from 'src/app/toaster.service';
import { User } from 'src/app/user/user.model';
import { PathRegistration } from 'src/app/user/path-registration.model';
import { UserService } from 'src/app/user/user.service';
import { WalletService } from 'src/app/wallet/wallet.service';
import { WINDOW } from 'src/app/window.service';
import { environment } from 'src/environments/environment';
import { HomeUiService } from '../home-ui.service';
import { YourPathNewComponent } from '../your-path-new/your-path-new.component';
import { YourPathComponent } from '../your-path/your-path.component';
import { MotionDuration, MotionEasing } from '../../constants/motion-tokens';
import { AssessmentBlock, ContentModel, DailySteps, Screens, ScreenTypes } from 'src/app/path/path-daily-steps-v2.model';
import { KyperChapters, Path } from 'src/app/path/path-v2.model';
import { ContentSurveyComponent } from 'src/app/content-survey/content-survey.component';
import { KyperDataApiService } from 'src/app/services/kyper-data-api.service';
import { CalendarCopyService } from 'src/app/calendar-copy.service';
declare var $: any

export interface CalendarParams {
  title: String,
  startDate: Date
  endDate: Date,
  eventLocation: String,
  notes: String,
  endEventTime: any,
  frequency: string
}

export interface RoutineListItem {
  id: number,
  title: string,
  routineRepLogs: any[]
}

export interface JournalPostItem {
  [journalPostItem: string]: any;
}

@Component({
  selector: 'app-daily-steps-content-web-modal-v2',
  templateUrl: './daily-steps-content-web-modal-v2.component.html',
  styleUrls: ['./daily-steps-content-web-modal-v2.component.scss'],
    animations: [
      fadeInLeftAnimation({ duration: 300 }),
      fadeInRightAnimation({ duration: 300 }),
      slideInUpAnimation({ duration: 300 }),
      expandOnEnterAnimation({ duration:400}),
      slideInDownAnimation({ duration: 300 }),
      trigger('collapseAnimation', [
        state('open', style({ height: '*', opacity: '1',bottom:'0px' })),
        state('closed', style({ height: '0', overflow:'hidden', opacity: '0',bottom:'0px' })),
        transition('open <=> closed', animate('0.3s ease-in-out')),
      ]),

      trigger('backgroundFade', [
        transition(':enter', [
          style({ opacity: 0 }),
          group([
            animate(
              `${MotionDuration.SHORT}ms ${MotionEasing.ENTER}`,
              style({ opacity: 1 })
            ),
            query('@*', animateChild(), { optional: true })
          ])
        ])
      ]),

       trigger('animateContent', [
        transition(':enter', [
          query(':scope > *', [
            style({ opacity: 0, transform: 'translateY(8px)' })
          ], { optional: true }),
  
          query(':scope > *', [
            stagger(100, [
              animate(
                '800ms cubic-bezier(0.76, 0, 0.24, 1)',
                style({ opacity: 1, transform: 'translateY(0)' })
              )
            ])
          ], { optional: true })
        ]),
  
        transition(':leave', [
          animate(
            '0.3s cubic-bezier(0.76, 0, 0.24, 1)',
            style({ opacity: 0, transform: 'translateY(-75px)' })
          )
        ])
      ])

    ],
  
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DailyStepsContentWebModalV2Component implements OnInit,AfterViewInit, DoCheck, OnDestroy  {

  @Input() mode: string = 'question'
  @ViewChildren('dailyContentScreen') dailyContentScreens: QueryList<
    ElementRef
    >
  @ViewChildren('pollContentOverflow') pollContentOverflows!: QueryList<ElementRef>
  @ViewChildren('scrollContainer') scrollContainers!: QueryList<ElementRef>
  @ViewChild('onboardingLearningModal') onboardingLearningModal: OnboardingLearningNotificationComponent;
  @ViewChildren('fabComponent,fabComponent1,fabComponent2,fabComponent3,fabComponent4,fabComponent5,fabComponent6,fabComponent7,fabComponent8,fabComponent9,fabComponent10,fabComponent11,fabComponent12,fabComponent13,fabComponent14,fabComponent15,fabComponent16,fabComponent17,fabComponent18,fabComponent19,fabComponent20,fabComponentNps') fabComponents: QueryList<IonFab>;
  @ViewChild('documentV2Component') documentV2Component: DocumentV2Component
  @ViewChild('contentSurveyComponent') contentSurveyComponent: ContentSurveyComponent
  @ViewChild('calendarButtonsContainer') calendarButtonsContainer: ElementRef
  @ViewChildren('disableListener') disableListener: ElementRef[]
  @ViewChild("onboardLearningComponent") onboardLearningComponent: OnboardingLearningNotificationComponent;
  @ViewChild(MicroActionChatbotV1Component) microActionChatbotV1Component: MicroActionChatbotV1Component;
  benchLinearScale:string;
  selectedQuestionStep;
  FromChildData: string;
  @ViewChild(LinearScaleComponent) child;

  @Input() currentDay: number
  @Input() startFromScreen: string
  @Input() currentOpenedChapter
  contentScreens;
  currentPath: Path
  currentUser: User
  actionList
  currentClient: Client
  isMobileWeb=false
  isMobileWebIos =false
  action;
  poll
  document
  inoutScreen
  habit
  routine;
  calendarParams: CalendarParams
  routineClendarParams: CalendarParams
  question
  currentScreenId: string
  currentScreenIndex = 0
  screensIds = []
  screensEnabled = {}
  allScreens: any[] = [] // Flattened list of all screens sorted by screenOrder
  backTo: string
  contentSurvey
  hasNativeCalendar: boolean
  loading: boolean
  recurrenceInterval: string
   flag= false;
  isDisabled = false;
  subTitleName: string
  noteText: String
  browserRefresh;
  showAnimation:boolean;
  isRoutine: boolean = true
  public toggleButtonValue = "routines";
  habits: HabitListItem[];
  previousSkippedScreenIndex = -1
  routineSkipped = false;
  learningTime;
  isHabit: boolean
  routines: any;
  routineData: RoutineListItem[];
  addedManagerEmail;
  routineList: any;
  checkCurrentDay: boolean
  isUpdated: boolean
  cloudCalendarExpanded: boolean;
  cloudCalendarSet: boolean;
  isMobile: boolean;
  @ViewChild('scrollContainer', { static: false }) scrollContainerRef: ElementRef;
  @ViewChild('questionHeading')
  questionHeading: ElementRef;
  @ViewChildren('disableCard') disableCard: ElementRef[];
  @ViewChildren('disableCardHeader') disableCardHeader: ElementRef[]
  isScrolledBottom: boolean = false
  lastDayOfContent: any
  questionType: string
  showRoutine: boolean = false
  responseData: any
  scaleData: any
  isImInCompleted: boolean
  linearScale;
  isLevelCompleted: boolean
  buttonsArray = ['Day(s) & time', 'Location', 'Activity', 'Person', 'Other']
  selectedCueOption: string
  isScreenViewed: boolean
  location: string
  activity: string
  typeValue: string
  commitData: any
  levelId: any
  commitType: any
  routineDay: any
  routineTime: any
  activityCueTime: any
  makeCommitment: any
  localRoutineData: any
  subRoutineAnswer: any
  scheduledDay: number
  colorArray = []
  isEventCreated: boolean
  selectedTimings = [];
  dayTimeArray: any
  routineVersion: boolean
  enabledAttributes: any
  isRoutineEdited: boolean
  isonboardingcompleted: any;
  convertedTimings = [];
  selectedDates: string[]
  isQuestionCompleted: boolean
  modalDataResponse: any;
  isCommented: boolean
  allowNextScreen: boolean
  hidePreviousScreen: boolean;
  leftSwipe: boolean = false;
  rightSwipe: boolean = false;
  animation = ['fadeInLeft', 'fadeInRight'];
  allowScreenCount: boolean
  allowForceRankButton: boolean
  currentStep: number;
  totalSteps: number;
  public pathRegistration: CurrentPathRegistration
  library: Library
  savedLibraryPosts: any
  postToJournal: JournalPostItem
  recentSavedPost: any
  savedScreenId: string
  isAlreadyPresent= undefined;
  @Input() showFilledBookmark: boolean
  isDocumentOnly: boolean
  prevPathData: any
  selectedLevels = []
  isLevelsSelected: boolean
  unCheckedLevels: any =[]
  indexOfLevel: number
  levelUpdated: any
  toDos: TodoListModel
  showUpdatedScreens: boolean
  pathAverage;
  showBackdrop =false;
  dailyStepsArray: KyperChapters[];
  todoRoutines: any
  todoActions: any
  hideDropDown=false;
  appStateTodo: any
  videoFormats = ['.mp4', '.mov', '.avi', '.avchd', '.f4v', '.mkv', '.wmv','youtube.com', 'webm', 'html5', 'HTML5', 'watch'];
  audioFormats = [".mp3"];  
  startTime: any
  endTime: any
  surveyStats: any
  reflection
  textareaElement: any
  textareaContainer: any
  IsOptionSelected: boolean;
  enableBlur: boolean[]=[];
  isWeldoneScreenCalled =false;
  showScrollbar = false;
  notLastStep = false;
  presignedUrl: any
  pdfSrc: any;
  multiplePolls: any;
  multipleOnboardingSettings;
  learningScreenData;
  managerEmailScreenData;
  profileScreenData;
  accountabilityEmailData;
  accountabilityEmails = [];
  isPhotoUploaded: boolean;
  stepActionPointInfo = [];
  pathPersonalizationData;
  npsScreenData: any = null;
  streaksInfo
  userShuffledChapters
  chaptersCountVisibleInPathPersonalization = [];
  addAnimation = false;
  dragOffset: number = 0;
  activeChapterIndex=0;
  activeStepIndex=0;
  routineScreenImage
  htmlMiniApp;
  hasScrollbar = false;
  private resizeObserver!: ResizeObserver;
  showPollScrollToBottom = false;
  showScrollToBottom = false;
  private readonly BOTTOM_THRESHOLD = 1;
  private pollResizeObserver?: ResizeObserver;
  private pollContentOverflowsSub?: Subscription;
  private scrollContainersSub?: Subscription;
  private scrollEndFallbackTimeouts = new Set<ReturnType<typeof setTimeout>>();
  backgroundImage: string | null = null;
  headingFontSize = 20.84;
  bodyFontSize = 14.44;
  private fontSizeSubscription: any;
  private fontSizeSaveSubject = new Subject<{ headingFontSize: number; bodyFontSize: number }>();
  private fontSizeSaveSubscription?: Subscription;
  chatbotEngaged = false;
  private microActionSub?: Subscription;

  constructor(
    private calendarCopy: CalendarCopyService,
    public appState: AppState,
    private router: Router,
    public route: ActivatedRoute,
    private themeService: ThemeService,
    private sessionService: SessionService,
    private spinnerService: SpinnerService,
    private dailyStepsService: DailyStepsService,
    private habitService: HabitService,
    private cdRef: ChangeDetectorRef,
    private cordovaService: CordovaService,
    private homeService: HomeV5Service,
    private dialog: MatDialog,
    private i18n:I18n,
    private tostrService: ToasterService,
    private routineService: RoutineService,
    private walletService: WalletService,
    private calendarService: CalendarService,
    private pollService: PollService,
    private routinev2Service: RoutineV2Service,
    private appConstantService: AppConstantsService,
    public modalCtrl: ModalController,
    public navCtrl: NavController,
    public utilService: UtilityService,
    public homeUIService: HomeUiService,
    private userService: UserService,
    public modalController: ModalController,
    private homev5Service: HomeV5Service,
    private libraryService: LibraryService,
    private toasterService: ToasterService,
    private renderer: Renderer2,
    private keyboard: Keyboard,
    private alertController: AlertController,
    private platform: Platform,
    private transfer: FileTransfer, 
    private file: File,
    private http: HttpClient,
    private kyperApiService:KyperDataApiService,
    private microActionStateService: MicroActionStateService,
    @Inject(WINDOW) private window: Window
  ) {
    const w: any = window
    this.hasNativeCalendar = this.cordovaService.onCordova && w && w.plugins && w.plugins.calendar
    this.presignedUrl = environment.preSignedUrl
    this.currentPath = this.appState.get('currentPath')
    this.isUpdated = this.appState.get('isUpdatedMyCommitments')
    if (this.isUpdated) {
      this.appState.set('isUpdatedMyCommitments', false)
      this.refresh()
    }
    this.addedManagerEmail = this.appState.get("managerEmail");
    this.hidePreviousScreen = this.appState.get('hidePrevScreen');
    this.accountabilityEmails = this.appState.get("accountabilityEmails");
  }

  init() {
    this.currentUser = this.appState.get('currentUser')
    this.currentPath = this.appState.get('currentPath')
    this.currentClient = this.appState.get('currentClient')
    this.isMobile = this.appState.get('isMobile')
      this.isRoutineEdited = this.appState.get('isRoutineEdited')
    this.enabledAttributes = this.appState.get("routineVersion")
    this.pathRegistration = this.appState.get('pathRegistration')
    if (this.pathRegistration?.pathData?.headingFontSize && this.pathRegistration?.pathData?.bodyFontSize) {
      this.homeUIService.updateFontSize(this.pathRegistration.pathData.headingFontSize, this.pathRegistration.pathData.bodyFontSize);
    }
    this.prevPathData = this.appState.get('prevPathData')
    this.selectedLevels = this.appState.get('selectedLevelIds')
    this.levelUpdated = this.appState.get('levelUpdated')
    this.appStateTodo = this.appState.get('toDos')
    this.todoRoutines = this.appState.get('todoRoutines')
    this.surveyStats = this.appState.get('surveyStats')
    this.todoActions = this.appState.get('todoActions')
    this.textareaElement = this.appState.get('textareaElement')
    this.textareaContainer = this.appState.get('textAreaContainer')
    this.streaksInfo = this.appState.get('dailyStreaksInfo');
    let learningTime = localStorage.getItem("learningTime");
    if (learningTime) {
      this.learningTime = learningTime;
    } else {
      if (this.pathRegistration && this.pathRegistration.pathData) {
        this.learningTime = this.pathRegistration.pathData.loginReminderTime;
      }
    }    
    if (this.enabledAttributes?.routineVersion) {
      this.routineVersion = this.enabledAttributes?.routineVersion
    } else {
      this.routineVersion = false
    }

    this.themeService.setTheme(this.currentPath.getTheme())
    this.multiplePolls = this.filterStepsByContentType('poll')
    if( this.multiplePolls?.length>0) {
      this.enableBlur = new Array(this.multiplePolls?.length)?.fill(false);
    }
    this.multiplePolls = this.multiplePolls?.slice()?.sort((a, b) => a?.screenPosition - b?.screenPosition);
    // this.currentDay = +this.route.snapshot.paramMap.get('day')
    // this.startFromScreen = this.route.snapshot.queryParamMap.get(
    //   'startFromScreen'
    // )
    this.routineList = this.appState.get('routines')
    this.backTo = this.route.snapshot.queryParamMap.get('backTo')

    this.lastDayOfContent = this.currentPath.lastDayOfContent()

    this.levelId = this.appState.get('LevelNumber')
    
    if (!this.levelId) {
      this.levelId = 1
    }
    this.startTime = new Date();
    this.setNewContent()    
    this.appState.set('oldActionPoints', this.walletService.actionPoints.value)
    if (!this.appState.get('indexOfLevel')) {
      this.indexOfLevel = 0
    } else {
      this.indexOfLevel = this.appState.get('indexOfLevel')
    }
    
    setTimeout(() => {
      this.addAnimation = true;
    }, 3000);
    
  }

   removeAnimation() {
    this.addAnimation = false;
    
    setTimeout(() => {
      this.addAnimation = true;
    }, 3000);
  }
  toggleTheme() {
    this.homeUIService.toggleTheme();
    this.cdRef.detectChanges();
  }

  increaseFontSize() {
    if (this.headingFontSize < 30) {
      const newHeading = Math.round((this.headingFontSize + 2) * 100) / 100;
      const newBody = Math.round((this.bodyFontSize + 2) * 100) / 100;
      this.homeUIService.updateFontSize(newHeading, newBody);
      this.fontSizeSaveSubject.next({ headingFontSize: newHeading, bodyFontSize: newBody });
    }
  }

  decreaseFontSize() {
    if (this.headingFontSize > 14 && this.bodyFontSize > 12) {
      const newHeading = Math.round((this.headingFontSize - 2) * 100) / 100;
      const newBody = Math.round((this.bodyFontSize - 2) * 100) / 100;
      this.homeUIService.updateFontSize(newHeading, newBody);
      this.fontSizeSaveSubject.next({ headingFontSize: newHeading, bodyFontSize: newBody });
    }
  }

  private savePathRegistrationFontSize(headingFontSize: number, bodyFontSize: number) {
    this.pathRegistration = this.pathRegistration || {};
    this.pathRegistration.pathData = this.pathRegistration.pathData || {};
    this.pathRegistration.pathData.headingFontSize = parseFloat(String(headingFontSize));
    this.pathRegistration.pathData.bodyFontSize = parseFloat(String(bodyFontSize));
    this.appState.set('pathRegistration', this.pathRegistration);

    const { __typename, ...pathData } = this.pathRegistration.pathData as any;
    const pathRegistration = new PathRegistration({
      userId: this.currentUser?.id,
      pathId: this.currentPath?.id,
      pathData,
    });
    this.userService.savePathRegistration(pathRegistration).subscribe(
      (response: any) => {
        this.pathRegistration = response.data.updatePathRegistration;
        this.appState.set('pathRegistration', this.pathRegistration);
      },
      (error) => {
        console.log('Error saving font size preference', error);
      }
    );
  }

  onBackgroundImageChange(value: string) {
    this.backgroundImage = value;
  }

  ngAfterViewInit() {
    this.fontSizeSubscription = this.homeUIService.fontSize$.subscribe(({ heading, body }) => {
      this.headingFontSize = heading;
      this.bodyFontSize = body;
    });
    this.fontSizeSaveSubscription = this.fontSizeSaveSubject
      .pipe(debounceTime(500))
      .subscribe(({ headingFontSize, bodyFontSize }) => {
        this.savePathRegistrationFontSize(headingFontSize, bodyFontSize);
      });
    this.pollContentOverflowsSub = this.pollContentOverflows.changes.subscribe(() => {
      setTimeout(() => this.observeActivePollContainer(), 100);
    });
    this.scrollContainersSub = this.scrollContainers.changes.subscribe(() => {
      setTimeout(() => this.observeActiveScrollContainer(), 100);
    });
    this.activeChapterIndex = this.appState.get('currentActiveChapter')
    this.activeStepIndex = this.appState.get('reviewingStepIndex')
    if(!this.currentOpenedChapter && this.currentOpenedChapter!=0 ) {
      this.currentOpenedChapter = this.activeChapterIndex;
    }
    // This modal has no route, so it takes its indexes from shared state — which the opener may only
    // half-set (your-path-new sets the step index and not the chapter) and which may still name the
    // step last reviewed. `currentDay` identifies the step, so resolve both indexes from it; an
    // unmatched position leaves them exactly as they came.
    const here = this.resolveStepInHand()
    this.currentOpenedChapter = here.chapterIndex
    this.activeStepIndex = here.stepIndex
    this.init();
    console.log("path init", this.currentPath);
    this.scheduledDay = this.appState.get("scheduleDayForCurrentStep")
    // if(this.poll?.priorQuestionId && this.poll?.ptype =='linear' && this.poll?.benchmarkType==2) {
    //   this.getScaleAnswers(this.currentUser.id,this.currentPath.id,this.poll.priorQuestionId)
    // }
    // this.multiplePolls.forEach(element => {
    //   if(element?.priorQuestionId && element?.ptype =='linear' && element?.benchmarkType==2) {
    //     this.getScaleAnswers(this.currentUser.id,this.currentPath.id,element.priorQuestionId)
    //   }
    //   if(element?.ptype =='mcq' && !element?.rationale){
    //     this.hideDropDown =true;
    //   }
    //   else {
    //     this.hideDropDown =false;
    //   }
    // });
        // let activeStepIndex= this.appState.get('currentActiveStepIndex')
    if (localStorage.getItem('isBeginClicked') === 'true' && this.currentDay ==this.scheduledDay && this.dailyStepsArray[this.currentOpenedChapter]?.steps[this.activeStepIndex]?.stepStatus!='Review') {
      this.utilService.setScreenData(this.currentScreenIndex, this.currentDay, this.screensIds)
      this.utilService.setScreenCount()
      localStorage.setItem('isBeginClicked', 'false')
    }
     if (this.allowScreenCount && this.currentDay ==this.scheduledDay && this.dailyStepsArray[this.currentOpenedChapter]?.steps[this.activeStepIndex]?.stepStatus!='Review') {
      this.utilService.setScreenData(this.currentScreenIndex, this.currentDay, this.screensIds)
    }
        
        let lastScreenId = localStorage.getItem(
          `Toggle:User:${this.currentUser.id}:DayProgress:${this.currentPath.id}:${this.currentDay}`
        );
        let sid = -1;
        let screenscount = this.appState.get('screensViewed')
        let screenStatus = this.appState.get('screenStatus');
        let screensViewed;
        let routineScreenCount =6;
        if(this.pathRegistration?.screensViewed ){
           screensViewed =this.pathRegistration?.screensViewed[this.pathRegistration?.screensViewed?.length-1]
        }
        else if (screenscount) {
          screensViewed = screenscount[screenscount?.length-1]
       }
        // Only replay a recorded position that belongs to the path in hand: a switch whose cleanup
        // never ran leaves the previous one's behind.
        if (screenStatus === 2 && this.utilService.isScreenPositionFromCurrentPath()) {
          this.goToScreenAsPerVisited(screenStatus)
        } else {
          if (this.startFromScreen) {
            sid = this.deepLinkIndex()
          // } else if (lastScreenId) {
          //   sid = this.screensIds.indexOf(lastScreenId)  
          }
          else if (this.resumeIndexFromLocalProgress() !== -1) {
            sid = this.resumeIndexFromLocalProgress()
            lastScreenId = this.screensIds[sid]
          }
          else if(screensViewed?.visitedScreens) {
            if (screensViewed?.step == this.currentDay && this.dailyStepsArray[this.currentOpenedChapter]?.steps[this.activeStepIndex]?.stepStatus != 'Review') {
              sid = screensViewed?.visitedScreens - 1;
              if (screensViewed?.totalScreens == this.screensIds?.length) {
                lastScreenId = this.screensIds[sid]
              }
              else if (this.screensIds?.length + routineScreenCount == screensViewed?.totalScreens) {
                sid = sid - routineScreenCount;
                lastScreenId = this.screensIds[sid]
              }
            }
          }
          if ((lastScreenId || this.startFromScreen) && sid !== -1) {
            this.currentScreenIndex = sid
            this.currentScreenId = this.screensIds[sid]
          } else {
            this.currentScreenIndex = 0
            this.currentScreenId = this.screensIds[0]
          }
          setTimeout(()=>{
            this.showCurrentScreen()
          },150)
          this.cdRef.detectChanges()
        }
    }
  saveSurvey(survey) {
    this.contentSurveyComponent.saveSurvey(survey);
  }

  saveManagerEmail() {
  this.addedManagerEmail = this.appState.get("managerEmail");
    let answers = {};
    // The address to save now lives in the draft: appState "managerEmail" holds only what the server
    // has already stored, so reading it here would post `undefined` and wipe a saved address.
    const pendingManagerEmail = this.appState.get("managerEmailDraft") || this.addedManagerEmail;
    if (pendingManagerEmail && this.onboardingLearningModal?.isManagerEmailAdded&&(!this.addedManagerEmail || !this.currentUser?.managerEmails?.length)) {
      this.homeUIService.saveManagerEmailAddress(answers, pendingManagerEmail, this.currentDay, this.managerEmailScreenData.screenContentId, this.managerEmailScreenData.stepId);
       this.onboardingLearningModal.isManagerEmailAdded = undefined;
    }
  }

  toggleBackdrop(val) { 
    if(!val){
      this.showBackdrop = true;
      this.appState.set('isFabClicked',true)
    }  
    this.showFilledBookmark = true 
  }

  contentClick(event: Event) {
  
   if (this.appState.get('isFabClicked')==false && this.showBackdrop) {
       this.fabComponents.toArray()?.forEach((ele)=>{
        this.showBackdrop = false;
        this.showFilledBookmark = false;
        if(ele?.activated){
          ele?.close();
        }
    })
  }   
  if(this.appState.get('isFabClicked')) {
    this.appState.set('isFabClicked',false)
  }
   
  }
  
  @HostListener('window:scroll')
  onWindowScroll() {
    
  }
  toggleScrollbar(): void {
  
    if (this.isMobile) {
      let hasScrollbar;
     setTimeout(()=>{

    
     this.dailyContentScreens?.forEach((ele)=>{
      hasScrollbar = ele.nativeElement.scrollHeight >= this.window.innerHeight
      if (hasScrollbar && !this.showScrollbar) {
        this.renderer.addClass(ele.nativeElement, 'show-scrollbar');
        this.showScrollbar = true;
      } else if (!hasScrollbar && this.showScrollbar) {
        this.renderer.removeClass(ele.nativeElement, 'show-scrollbar');
        this.showScrollbar = false;
      }
     })
    },500);
 
    }
    
  }
  async goToScreenAsPerVisited(screenStatus) {
    if (!this.pathRegistration?.screensViewed) {
      let steps = this.appState.get('stepsArray')
      let stepsArray = this.homev5Service.removeDuplicates(steps, "step");
      await this.calculateSteps(stepsArray, screenStatus)
    } else {
      let steps = this.pathRegistration?.screensViewed
      let stepsArray = this.homev5Service.removeDuplicates(steps, "step");
      await this.calculateSteps(stepsArray, screenStatus)
    }
  }
  blurCard(enable, linearScale?,pathAverage?,event?,index?) {
    let pollObj = {
      poll: event?.poll,
      pollIndex: index
    }
    this.appState.set('singlePoll',pollObj)
    this.enableBlur[index] =enable;
    this.linearScale =linearScale;
    this.pathAverage= pathAverage;
    // let id = document.getElementsByClassName('back-available')[index]
    // if(event?.poll?.screen?.contentType =='linear'){
    //   if(enable ==true || this.enableBlur[index]){
    //     this.disableCard?.forEach((element, index) => {
    //       if(this.enableBlur[index]) {
    //         this.renderer.addClass(element?.nativeElement, 'container-blur');
    //       }
         
    //     });
    //     this.disableCardHeader?.forEach((element,index) => {
    //       if(this.enableBlur[index] || this.enableBlur[index]) {
    //         this.renderer.addClass(element?.nativeElement, 'container-blur');
    //       }
    //     });
    //     if(!this.isMobile) {
    //       // id?.setAttribute('style','display:grid !important;')
    //     }
  
    //   }
    //   else if(enable ==false) {
    //     this.disableCard?.forEach((element, index) => {
    //       if(!this.enableBlur[index]) {
    //         this.renderer.removeClass(element?.nativeElement, 'container-blur');
    //       }
         
    //     });
    //     this.disableCardHeader?.forEach((element,index) => {
    //       if(!this.enableBlur[index]) {
    //         this.renderer.removeClass(element?.nativeElement, 'container-blur');
    //       }
    //     });
    //     if(!this.isMobile) {
    //       // id?.setAttribute('style','display:block !important;')
    //     }
    //   }
    // }
     if(event?.poll?.screen?.contentType =='mcq' || event?.poll?.screen?.contentType =='linear' || event?.poll?.screen?.contentType =='force_rank') {
      if((enable ==true || this.enableBlur[index]) && event?.poll?.screen?.content?.keyLearning){
        this.disableCard?.forEach((element, index) => {
          if(this.enableBlur[index]) {
            this.renderer.addClass(element?.nativeElement, 'container-blur');
          }
         
        });
        this.disableCardHeader?.forEach((element,index) => {
          if(this.enableBlur[index]) {
            this.renderer.addClass(element?.nativeElement, 'container-blur');
          }
        });
        if(!this.isMobile) {
          // id?.setAttribute('style','display:grid !important;')
        }
  
      }
      else if(enable ==false) {
        this.disableCard?.forEach((element, index) => {
          if(!this.enableBlur[index]) {
            this.renderer.removeClass(element?.nativeElement, 'container-blur');
          }
         
        });
        this.disableCardHeader?.forEach((element,index) => {
          if(!this.enableBlur[index]) {
            this.renderer.removeClass(element?.nativeElement, 'container-blur');
          }
        });
        if(!this.isMobile) {
          // id?.setAttribute('style','display:block !important;')
        }
      }
    }
   
  }

  fetchContainerBlurClassStatus(screenContent) {
      if(screenContent?.contentType =='mcq' || screenContent?.contentType =='linear' || screenContent?.contentType =='force_rank') {
        this.disableCard?.forEach((element, index) => {
          if(this.enableBlur[index]) {
            this.renderer.addClass(element?.nativeElement, 'container-blur');
          }
         
        });
        this.disableCardHeader?.forEach((element,index) => {
          if(this.enableBlur[index]) {
            this.renderer.addClass(element?.nativeElement, 'container-blur');
          }
        });
        if(!this.isMobile) {
          // id?.setAttribute('style','display:grid !important;')
        }
    }
  }
  setScreenNav(screenStatus) {
    this.currentScreenIndex = 0
    this.currentScreenId = this.screensIds[0]
    let sid = this.currentStep;
    if (screenStatus == 2) {
      this.currentScreenIndex = sid
      this.currentScreenId = this.screensIds[sid]
    }
    this.showCurrentScreen()
    this.cdRef.detectChanges()
  }
  storeLevelsOrderPayload() {
    let levelsArray=[];
     if (this.selectedLevels && this.selectedLevels?.length>0) {
      this.selectedLevels?.forEach(element => {
        levelsArray.push(element.id)
      });
     }
    levelsArray = [...new Set(levelsArray)]
      let payload = {
        // routineInfoId:this.routine?.id,
        // pathId:this.currentPath.id,
        // userId:this.currentUser.id ,
        // isMadatory: true,
        // enabled:true,
        // currentDay:this.currentDay,
        // levelsArray:levelsArray
 
        step_id:this.routine?.stepId,
        screen_id:this.routine?.screenId,
        screen_content_id:this.routine?.screenContentId,
        is_habit_opted:false,
        habit_group_id: this.routine?.screenContentId,
        // habit_id: 1,
        selected_habit_ids:levelsArray
      };
    this.appState.set('levelsOrderPayload', payload)
  }

  private observeActiveScrollContainer(): void {
    const el = this.scrollContainers?.find(
      ref => ref.nativeElement.closest('.daily-content-screen')?.id === this.currentScreenId
    );
    if (el) {
      this.initResizeObserver(el.nativeElement);
    } else {
      this.resizeObserver?.disconnect();
      this.hasScrollbar = false;
      this.showScrollToBottom = false;
    }
  }

  initResizeObserver(el: HTMLElement) {
    this.resizeObserver?.disconnect();
    this.hasScrollbar = el.scrollHeight > el.clientHeight;
    this.showScrollToBottom = this.hasScrollbar;
    this.cdRef.detectChanges();
    this.resizeObserver = new ResizeObserver(() => {
      this.hasScrollbar = el.scrollHeight > el.clientHeight;
      this.showScrollToBottom = this.hasScrollbar;
      this.cdRef.detectChanges();
    });
    // `el` itself is a fixed-size box (absolutely positioned, top/bottom pinned), so its own
    // box size never changes when inner content grows/settles asynchronously. Observe its
    // children too so late-rendering content (e.g. onboarding-learning-notification's async
    // pickers/images) still triggers a recheck of el's scrollHeight vs clientHeight.
    this.resizeObserver.observe(el);
    Array.from(el.children).forEach(child => this.resizeObserver.observe(child));
  }

  // setPoll() enables every poll in `multiplePolls` up front (screensEnabled[...] = true), so
  // while a poll step is active, ALL #pollContentOverflow containers exist in the DOM at once —
  // non-active ones are merely hidden via the 'show' class (see showCurrentScreen()). A single
  // @ViewChild only ever binds to the first one, so we track the QueryList instead and pick the
  // container belonging to the currently active screen.
  private observeActivePollContainer(): void {
    const el = this.pollContentOverflows?.find(
      ref => ref.nativeElement.closest('.daily-content-screen')?.id === this.currentScreenId
    );
    this.pollResizeObserver?.disconnect();
    if (el) {
      this.checkIfPollScrollable(el);
      this.pollResizeObserver = new ResizeObserver(() => this.checkIfPollScrollable(el));
      this.pollResizeObserver.observe(el.nativeElement);
    } else {
      this.showPollScrollToBottom = false;
    }
  }

  checkIfPollScrollable(elRef: ElementRef): void {
    const el = elRef?.nativeElement;
    if (!el) return;
    this.showPollScrollToBottom = el.scrollHeight > el.clientHeight;
    this.cdRef.detectChanges();
  }

  private setScrollToBottomFlag(target: 'poll' | 'generic', value: boolean): void {
    if (target === 'poll') {
      this.showPollScrollToBottom = value;
    } else {
      this.showScrollToBottom = value;
    }
  }

  bottomonScroll(elRef: ElementRef | HTMLElement, target: 'poll' | 'generic' = 'generic'): void {
    const el = (elRef as ElementRef)?.nativeElement ?? elRef as HTMLElement;
    const distanceFromBottom = el.scrollHeight - el.scrollTop - el.clientHeight;
    this.setScrollToBottomFlag(target, distanceFromBottom > this.BOTTOM_THRESHOLD);
    this.cdRef.detectChanges();
  }

  scrollToBottom(elRef: ElementRef | HTMLElement, target: 'poll' | 'generic' = 'generic'): void {
    const el = (elRef as ElementRef)?.nativeElement ?? elRef as HTMLElement;
    this.setScrollToBottomFlag(target, false);
    el.scrollTo({ top: el.scrollHeight - el.clientHeight, behavior: 'smooth' });

    let scrollEndFired = false;
    const checkScrollEnd = () => {
      scrollEndFired = true;
      this.scrollEndFallbackTimeouts.delete(timeoutId);
      const distanceFromBottom = el.scrollHeight - el.scrollTop - el.clientHeight;
      this.setScrollToBottomFlag(target, distanceFromBottom > this.BOTTOM_THRESHOLD);
      this.cdRef.detectChanges();
    };

    el.addEventListener('scrollend', checkScrollEnd, { once: true });
    const timeoutId = setTimeout(() => { if (!scrollEndFired) checkScrollEnd(); }, 500);
    this.scrollEndFallbackTimeouts.add(timeoutId);
  }



  ngOnDestroy() {
    // The whole flow is closing, so an unsaved manager email must not survive into the next open —
    // that has to show what the server stored. Screen-to-screen switches inside the flow destroy the
    // manager-email screen component but not this host, which is why the draft is cleared here.
    this.appState.set("managerEmailDraft", null);
    this.microActionSub?.unsubscribe();
    this.microActionStateService.notifyPageLeave();
    this.fontSizeSubscription?.unsubscribe();
    this.fontSizeSaveSubscription?.unsubscribe();
    this.appState.set('accountabilityEmailDraft', null);
    if (this.appState.get('accountabilityEmailsModified')) {
      mixpanel.track('In Steps-Accountability Email Auto-Saved On Instep Close', {
        currentDay: this.currentDay,
        userId: this.currentUser?.id,
        pathId: this.currentPath?.id
      });
      this.saveAccountabilityEmails();
      this.appState.set('accountabilityEmailsModified', false);
    }
    this.homeUIService.saveAndClearPendingChaptersOrder();
    // this.appState.set('tempReorderedChapterIds', null);
    if (this.appState.get('isLevelsReshuffled')) {
      this.storeLevelsOrderPayload()
    }
    if (this.routine && (this.appState.get('isLevelClosedBeforeCommit') == true || this.appState.get('IsRepsAppendAfterReoptCommit') == true)) {
        
      let openedRoutineInfo = {
        routine: this.routine,
        habits: this.routine?.habits?.[this.indexOfLevel]
      }
      this.appState.set('routinneLevelInfo', openedRoutineInfo)
    }  
     this.appState.set('prevRoutineTime', undefined)
    this.appState.set('prevdays', undefined)
    this.appState.set('prevTimings', undefined)
    this.appState.set('updateActionPoints', true)
    let scheduledStep = this.appState.get("scheduleDayForCurrentStep");
    this.appState.set('screenStatus', null);
    localStorage.setItem('screenStatus',null)
    this.appState.set('hidePrevScreen', false)
    this.appState.set("changeCue",false)
    console.log("this.routine", this.routine);
    if (!this.flag) {
      let activeStepIndex= this.appState.get('currentActiveStepIndex')
      if (this.allowScreenCount && this.currentDay ==scheduledStep && this.dailyStepsArray[this.currentOpenedChapter]?.steps[this.activeStepIndex]?.stepStatus!='Review'){
        this.utilService.setScreenData(this.currentScreenIndex, this.currentDay, this.screensIds, this.leavingBeforeEndOfStep())
        this.utilService.setScreenCount()
      }
      // this.fetchStepSatus();
      if (this.appState.get('routine_schedule_day')) {
        this.appState.set('routine_schedule_day', null)
      }
      this.sessionService.removeAppStateOnContentClose()
      let prevPathData = this.appState.get('prevPathData')
      if (prevPathData) {
        this.sessionService.changePathToLibrary(prevPathData)
        this.appState.set('prevPathData',undefined)
      }
    }
    this.resizeObserver?.disconnect();
    this.pollResizeObserver?.disconnect();
    this.pollContentOverflowsSub?.unsubscribe();
    this.scrollContainersSub?.unsubscribe();
    this.scrollEndFallbackTimeouts.forEach(id => clearTimeout(id));
    this.scrollEndFallbackTimeouts.clear();
  }
  calculateSteps(stepsArray: any[], screenStatus) {
    if (stepsArray && stepsArray?.length >= 1) {
      try {
        stepsArray?.forEach(element => {
          if (element.step === this.currentDay) {
            this.currentStep = element.visitedScreens - 1;
            this.totalSteps = element.totalScreens;
          }
        });
        // `visitedScreens` is deliberately one short when the learner left before the end-of-step
        // (see reserveLastScreen), so it describes what is safe to REPORT, not where they were.
        // The resume key carries the true position; prefer it whenever one was recorded.
        const resumeIndex = this.resumeIndexFromLocalProgress()
        if (resumeIndex !== -1) { this.currentStep = resumeIndex }
        if (this.currentStep !== this.totalSteps) {
          this.setScreenNav(screenStatus);
        } else {
          this.setScreenNav(null);
        }
      } catch (error) { }
    }
  }

  ngDoCheck() {
    this.userShuffledChapters = this.appState.get('userShuffledChapters');
    if (
      this.currentUser?.imageUrl?.endsWith("avatar.png") ||
      this.currentUser?.imageUrl === "nil"
    ) {
      this.isPhotoUploaded = false;
    } else {
      this.isPhotoUploaded = true;
    }     
    this.todoRoutines = this.appState.get('todoRoutines')
    this.todoActions = this.appState.get('todoActions')
    this.isScreenViewed = this.appState.get('isScreenViewed')
    this.isImInCompleted = this.appState.get('isImInCompleted')
    this.addedManagerEmail = this.appState.get("managerEmail");
    this.accountabilityEmails = this.appState.get("accountabilityEmails");
    let learningTime = localStorage.getItem("learningTime");
    if (learningTime) {
      this.learningTime = learningTime;
    } else {
      if (this.pathRegistration && this.pathRegistration.pathData) {
        this.learningTime = this.pathRegistration.pathData.loginReminderTime;
      }
    }
     if (this.appState.get('scheduledHabitId') && this.appState.get('isEventRescheduled')) {
      this.appState.set('scheduledHabitId', null)
      this.appState.set('isEventRescheduled', null)
      this.getActions(this.currentPath.id)
      this.getHabits(this.currentPath.id)
      this.cdRef.detectChanges()
    }
    this.getLocalRoutineData()
    this.cdRef.detectChanges()
    this.isQuestionCompleted = this.appState.get('isQuestionCompleted')
    this.isCommented = this.appState.get('isCommented')
    this.allowScreenCount = this.appState.get('allowScreenCount');
    this.savedLibraryPosts = this.appState.get('savedPosts')
    this.recentSavedPost = this.appState.get('recentSavedStep')
    this.allowNextScreen = this.appState.get('allowNext')
    this.surveyStats = this.appState.get('surveyStats')
    this.textareaElement = this.appState.get('textareaElement')
    this.textareaContainer = this.appState.get('textAreaContainer')
    if (this.textareaElement && this.screensIds[this.currentScreenIndex] === "daily-content-screen-reflection") {
      this.textareaElement.nativeElement.focus()
      this.utilService.enableHeight(this.textareaContainer, this.isMobile, this.platform, this.keyboard)
      this.appState.set('textareaElement', undefined)
    }
    if (this.allowNextScreen) {
      this.appState.set('allowNext', false)
      this.nextScreen()
    }
    this.selectedLevels =   [...new Set(this.appState.get('selectedLevelIds'))];
    this.levelUpdated = this.appState.get('levelUpdated')
    this.showUpdatedScreens = this.appState.get('showUpdatedScreens')
    this.unCheckedLevels = [...new Set(this.appState.get('unCheckedLevels'))]
    if (this.levelUpdated && this.todoRoutines) {
      this.todoRoutines?.forEach(todoRoutine => {              
        if(this.unCheckedLevels && this.unCheckedLevels?.length>0){
          function getUnique(arr) {
            const unique = arr.filter((id,index)=>{
              return arr.indexOf(id)===index
            })
            return unique;
          }
  
          let finalUncheckedLevels = []
          finalUncheckedLevels = getUnique(this.unCheckedLevels) 
          this.routine?.screen?.content?.habits?.forEach(routineLevel => {
            finalUncheckedLevels?.forEach(unCheckedLevel => {
              if (routineLevel.id === unCheckedLevel.id) {
                let originalIndex =  this.routine?.screen?.content?.habits?.findIndex(item => item.id === unCheckedLevel.id);
                // this.routine.levels.splice(originalIndex, 1)
                this.routine.screen.content.habits[originalIndex].enabled =false
                this.cdRef.detectChanges()
              }
            });
          })
        }
      });
      if (this.selectedLevels?.length>0 && this.selectedLevels?.length !== this.routine?.screen?.content?.habits?.length) {
        let isLevelAvailable,unavailableLevel;
        this.selectedLevels?.forEach((level) => {
          isLevelAvailable = this.routine?.screen?.content?.habits?.filter((subLevel) => subLevel?.id == level?.id)
          if (isLevelAvailable?.length == 0) {
            let routineScreen= this.currentPath.filterStepsByContentType('habits',this.dailyStepsArray[this.currentOpenedChapter]?.steps[this.activeStepIndex])?.[0]
            unavailableLevel = routineScreen?.screen?.content?.habits?.filter((subLev) => subLev?.id == level?.id)
            if (unavailableLevel?.length>0) {
              this.routine?.screen?.content?.habits?.push(unavailableLevel[0])
            }
          }
          })
      }
    }
    let activeStepIndex= this.appState.get('currentActiveStepIndex')
    // Where the learner is on screen. NOT a progress write, so it is recorded outside the guard
    // below, which needs `currentDay == scheduledDay` and so skips every step but the scheduled one.
    if (this.screensIds?.length && this.currentDay) {
      localStorage.setItem(this.resumeKey(), JSON.stringify(this.currentScreenIndex));
    }
    if(this.allowScreenCount && this.currentDay ==this.scheduledDay && this.dailyStepsArray[this.currentOpenedChapter]?.steps[this.activeStepIndex]?.stepStatus!='Review') {
    this.appState.set('currentScreenIndexAfterScreenView', this.currentScreenIndex)
    this.appState.set('currentDayAfterScreenView', this.currentDay)
    this.appState.set('screensIdsAfterScreenView', this.screensIds)
    this.utilService.stampScreenPosition()
    if(this.currentScreenIndex){
      localStorage.setItem('currentScreenIndexAfterScreenView', JSON.stringify(this.currentScreenIndex));
    }
    localStorage.setItem('currentDayAfterScreenView', JSON.stringify(this.currentDay));
    localStorage.setItem('screensIdsAfterScreenView', JSON.stringify(this.screensIds));
    localStorage.setItem('screenStatus', JSON.stringify(this.appState.get('screenStatus')));
    }
    if(this.appState.get('toDos')){
      localStorage.setItem('toDosWhenRefreshed', JSON.stringify(this.appState.get('toDos')));
    }

    if (!this.appState.get('indexOfLevel')) {
      this.indexOfLevel = 0
    }else{
      this.indexOfLevel = this.appState.get('indexOfLevel')
    }
    // if (this.routine?.levels?.length === this.selectedLevels?.length && !this.levelUpdated) {
    //   this.indexOfLevel = 0
    // }
    
  }

  getScaleAnswers(userId: number, pathId: number, questionId: number){
    let higherScale;
    const requestData = {
      'user_id': userId,
      'path_id': pathId,
      'linear_question_id': questionId
    }

    if(!requestData){
      // this.spinnerService.off();
    }else{
      console.log("requestdata",requestData)
      this.pollService.getLinearScaleAnswers(requestData).subscribe(
        (response) => {
          let answerList = response.data
          
          for (let linear of answerList ) {
            higherScale =linear?.question_higherscale?linear?.question_higherscale:10;
            this.benchLinearScale = linear.linear_rank.linear_rating+'/'+higherScale;
            this.selectedQuestionStep = linear.linear_rank.schedule_day
          }
          this.cdRef.detectChanges()
        },
        (error) => {
          this.tostrService.error(this.i18n.t('Something went wrong..! Try Again'))
        }
      )
    }
  }
  showCurrentScreen() {
    console.log('showCurrentScreen called',{ currentScreenId: this.currentScreenId, currentScreenIndex: this.currentScreenIndex, screenContent: this.allScreens[this.currentScreenIndex] });
    let currentScreen = this.appState.get('screenId')
    if (currentScreen) {
      this.dailyContentScreens.map(item => {
        const {
          nativeElement: { classList }
        } = item
        if (currentScreen) {
          this.currentScreenId = currentScreen
          this.appState.set('screenId', undefined)
          this.currentScreenIndex = 0
          if (this.currentScreenId === this.screensIds[0]) {
            classList?.add('hide-back-btn')
          }
          classList?.add('show')
          this.appState.set('screenId', undefined)
        }
      })
    }
    this.cdRef.detectChanges();
    this.dailyContentScreens.map(item => {
      // console.log('item: ', item);
      const {
        nativeElement: { classList }
      } = item

      if (item.nativeElement.id === this.currentScreenId) {
        localStorage.setItem(
          `Toggle:User:${this.currentUser.id}:DayProgress:${this.currentPath.id}:${this.currentDay}`,
          this.currentScreenId
        )
        if (this.currentScreenId === this.screensIds[0]) {
          classList?.add('hide-back-btn')
        }else{
          classList?.remove('hide-back-btn')
        }

        if (this.currentScreenIndex === 0) {
          this.savedScreenId = this.currentScreenId
          this.appState.set('savedScreenId', this.savedScreenId)
          localStorage.setItem(
            `PathProgress:User:${this.currentUser.id}:DayProgress:${this.currentPath.id}:${this.currentDay}`,
            this.currentScreenId
          )
        }

        classList?.add('show')
      } else {
        classList?.remove('show')
      }
    })
    this.cdRef.detectChanges() // LUMBA-1375
    setTimeout(() => this.observeActivePollContainer(), 100);
    setTimeout(() => this.observeActiveScrollContainer(), 100);
    if (this.currentScreenId === 'daily-content-screen-habit') {
      setTimeout(() => this.microActionChatbotV1Component?.scrollToBottom(), 100);
    }
  }

  openDocument(document, id) {
    let posts = this.appState.get("casualDocuments")
    let doc =this.appState.get('singleDocument');
    let post;
    posts?.forEach((doc)=>{
      if(doc.id ==id){
        post =doc;
      }
    })
    if(doc?.id ==post?.id) {
       post= doc;
    }
    this.appState.set('singleDocument', post)
    this.appState.set('journalPost', undefined)
    if ((post?.isrecommended && post?.isrecommended === true) || (post?.isRecommended && post?.isRecommended ==true)) {
      this.appState.set('isCasualDocument', true)
    }
    if(this.isMobile) {
      this.dialog.closeAll();
    }
    // else {
    //   this.modalController.dismiss();
    // }
    this.appState.set('journalPathName', this.currentPath.name)
    let stepNumber = this.dailyStepsArray[this.currentOpenedChapter]?.steps[this.activeStepIndex]?.position;
    this.appState.set('journalStepNumber', stepNumber)
    // this.appState.set('journalStepNumber', post.startDay)
    const url = post.link;
    if (this.audioFormats.some(el => url?.includes(el))) {
      console.log('Audio File');
      if(this.isMobile){
        this.homeUIService.openNextComponent(FullScreenAudioComponent, {data:post})
      }
      else {
        this.homeUIService.openNextComponent(FullScreenAudioComponent, {data:post},'desktop-library-custom')
      }
    } else if (this.videoFormats.some(el => url?.includes(el))) {
      console.log('Video File');
      if(this.isMobile){
        this.homeUIService.openNextComponent(FullScreenVideoComponent, {data:post})
      }
      else {
        this.homeUIService.openNextComponent(FullScreenVideoComponent, {data:post},'desktop-library-custom')
      }
    } else {
      console.log('Document');
      if(this.isMobile){
        this.homeUIService.openNextComponent(FullScreenDocumentComponent,{data:post})
      }
      else {
        this.homeUIService.openNextComponent(FullScreenDocumentComponent,{data:post},'desktop-library-custom')
      }
    }
  }
  fetchStepSatus(){
    let dailySteps = this.appState.get("DailyStepsData");
    dailySteps?.forEach((chapter) => {
      chapter?.steps?.forEach((stepItem: DailySteps, i) => {
        if (stepItem?.stepStatus === "Review" && i < chapter?.steps?.length) {
          this.appState.set('scheduleDayForCurrentStep', stepItem?.position+1);
          this.appState.set("currentScheduleDay", stepItem?.position+1);
        }
      });
    })
  }
  close(isInstepTodoScreen?) {
    this.clearAbandonedRestart();
    let scheduledStep = this.appState.get("scheduleDayForCurrentStep"); 
    // if (this.appState.get('isLevelCommited') !== false) {
     if (this.appState.get('IsRepsAppendAfterReoptCommit') == true) {
      this.homeUIService.closingModalOnClickingBackground();
    }
    if (this.appState.get('isLevelClosedBeforeCommit') == true) {
      this.homeUIService.closingModalOnClickingBackgroundForUnLockedCommit();
    }
    this.flag = true;
    // let activeStepIndex = this.appState.get('currentActiveStepIndex');
    if (this.allowScreenCount && this.currentDay ==scheduledStep && this.dailyStepsArray[this.currentOpenedChapter]?.steps[this.activeStepIndex]?.stepStatus!='Review'){
      console.log("called before closing step this.currentScreenIndex this.screensIds",this.currentScreenIndex,  this.screensIds, this.screensIds?.length)
      if (this.currentScreenIndex + 1 == this.screensIds?.length) {
        this.appState.set('isStreaksScreenNotVisited', true);
        this.updateStreaksData();
      }
      this.utilService.setScreenData(this.currentScreenIndex, this.currentDay, this.screensIds, this.leavingBeforeEndOfStep())
      this.utilService.setScreenCount()
    }
    if (this.appState.get('routine_schedule_day')) {
      this.appState.set('routine_schedule_day', null)
    }
    this.sessionService.removeAppStateOnContentClose()
    let prevPathData = this.appState.get('prevPathData')
      if (prevPathData) {
        this.sessionService.changePathToLibrary(prevPathData)
        this.appState.set('prevPathData',undefined)
    }
    if (this.backTo) {
      this.router.navigate([this.backTo])
      this.fetchStepSatus();
      this.appState.set('isHomeScreen', true)
    } else {
      // this.router.navigate(['/main'])
      if(isInstepTodoScreen =='isInstepTodoScreen'){
       this.modalController.dismiss({isInstepTodoScreen:true})
      }
      else{
        this.modalController.dismiss();
      }
      this.fetchStepSatus();
      this.appState.set('isHomeScreen', true)
    }
    if (this.appState.get('isRouteToLibrary')) {
      this.modalController.dismiss();
      this.fetchStepSatus();

      // this.router.navigate(['/main'])
   
      this.appState.set('isRouteToLibrary', undefined)
    }
    if(this.appState.get('isYourPathPrevious')) {
       this.appState.set('isYourPathPrevious',false);
       this.fetchStepSatus();
      let isChaptersEnabled = this.currentPath?.kyperChapters?.length>0 && this.currentPath['enabledAttributes']?.chapters ==true
       setTimeout(()=>{
        this.homeUIService.openNextComponent(isChaptersEnabled? YourPathNewComponent:YourPathComponent);
       },600);
    }
  // }
  // else {
  //   this.toasterService.warning(this.i18n.t('Please commit habit level before closing step'));
  // }
   
  }

  skipPreviousScreens(block = false) {
    let scheduledStep = this.appState.get("scheduleDayForCurrentStep");
    let activeStepIndex= this.appState.get('currentActiveStepIndex');
    if (block) { return false; }
      if (this.previousSkippedScreenIndex >= 0 && this.previousSkippedScreenIndex < this.screensIds?.length) {
      this.currentScreenIndex = this.previousSkippedScreenIndex;
    } else {
      for (let i = 0; i < 7; i++) {
        if (this.currentScreenIndex <= 0) {
          break;
        }
        this.currentScreenIndex--;
      }
    }

    if (this.allowScreenCount && this.currentDay ==scheduledStep && this.dailyStepsArray[this.currentOpenedChapter]?.steps[this.activeStepIndex]?.stepStatus!='Review') {
      this.appState.set('currentScreenIndexAfterScreenView', this.currentScreenIndex);
      localStorage.setItem('currentScreenIndexAfterScreenView', JSON.stringify(this.currentScreenIndex));
    }
  
    this.currentScreenId = this.screensIds[this.currentScreenIndex];
    this.showCurrentScreen();
  }
  private applySwipeStyle(offset: number, instant = false) {
    const screens = document.querySelectorAll<HTMLElement>('.desktop-daily-content-screens .daily-content-screen');
    screens.forEach(el => {
      el.style.transition = instant ? 'none' : 'transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
      el.style.transform = `translateX(${offset}px)`;
    });
  }

  private animateScreenTransition(direction: 'next' | 'prev', callback: () => void) {
    const containerWidth = document.querySelector<HTMLElement>('.desktop-daily-content-screens')?.offsetWidth || window.innerWidth;
    this.applySwipeStyle(direction === 'next' ? -containerWidth : containerWidth);
    setTimeout(() => {
      callback();
      this.applySwipeStyle(direction === 'next' ? containerWidth : -containerWidth, true);
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.applySwipeStyle(0);
        });
      });
    }, 300);
  }

  prevScreen(block = false, animate = true) {
    if (block) {
      return false
    }
    if (animate) {
      this.animateScreenTransition('prev', () => this.prevScreen(block, false));
      return;
    }
    this.checkLibraryStatus(this.poll, this.contentSurvey, this.document, this.question, this.habit, this.reflection,this.contentScreens)
    
    // Use allScreens array if available, otherwise fallback to screensIds
    if (this.allScreens && this.allScreens.length > 0) {
      if (this.currentScreenIndex > 0) {
        this.currentScreenIndex--;
        this.currentScreenId = this.allScreens[this.currentScreenIndex].id;
      }
    } else {
      this.currentScreenIndex--;
      this.currentScreenId = this.screensIds[this.currentScreenIndex];
    }
    
    this.showCurrentScreen()
    this.selectedCueOption = 'Day(s) & time'
    this.getLocalRoutineData()
    this.sessionService.removeAppStateOnContentPrev()
    if (this.routineSkipped && this.screensIds[this.currentScreenIndex] === "daily-content-screen-commit-routine") {
    this.skipPreviousScreens()
    }
    if (this.isScreenViewed && this.screensIds[this.currentScreenIndex] === "daily-content-screen-habit-loop") {
      this.prevScreen(false, false)
    }
    if (this.makeCommitment === 'no' && this.screensIds[this.currentScreenIndex] === "daily-content-screen-options") {
      this.prevScreen(false, false)
    }
    if (this.screensIds[this.currentScreenIndex] === "daily-content-screen-commit-routine") {
      console.log('1 :',);
      this.prevScreen(false, false)
      if (this.screensIds[this.currentScreenIndex] === "daily-content-screen-options") {
        console.log('2 :',);
        this.prevScreen(false, false)
      }
    }
    if (this.screensIds[this.currentScreenIndex] === "daily-content-screen-options") {
      console.log('3 :',);
      this.prevScreen(false, false)
    }
    this.showKeyboard()
    this.utilService.stopEmbeddedVideo()
  }

  /**
   * Number of routine levels currently selected. Mirrors the child routine list's
   * `checkedRoutineLevels` (selected when `enabled === true` or `undefined`; deselected when
   * `enabled === false`), so it reflects BOTH the server-loaded state and in-session toggles —
   * unlike the session-only appState `unCheckedLevels`/`selectedLevels`, which are empty on a
   * fresh load and would wrongly enable Next when the server has all levels deselected.
   */
  get selectedRoutineLevelsCount(): number {
    return (this.routine?.screen?.content?.habits || [])
      .filter((h: any) => h?.enabled === true || h?.enabled === undefined).length;
  }

  nextScreen(block = false, animate = true) {
    let scheduledStep = this.appState.get("scheduleDayForCurrentStep");
    this.endTime = new Date();
    let timeDiff = this.endTime - this.startTime; // time difference in milliseconds
    let seconds = Math.floor(timeDiff / 1000); // convert to seconds
    let minutes = Math.floor(seconds / 60); // convert to minutes
    let hours = Math.floor(minutes / 60); // convert to hours
    let timeSpent = hours + ":" + minutes + ":" + seconds; // format the time spent
    if (block) {
      return false
    }
    const isPersonalizationScreen = this.currentScreenId === 'daily-content-screen-path-personalization';
    const isPersonalizationRequired = this.dailyStepsArray?.length > 2;
    const isPersonalizationDone = this.userShuffledChapters?.chapterOrder &&
      (this.userShuffledChapters?.is_finalised ?? this.userShuffledChapters?.isFinalised);
    if (isPersonalizationScreen && isPersonalizationRequired && !isPersonalizationDone) {
      return false;
    }
    if (animate) {
      this.animateScreenTransition('next', () => this.nextScreen(block, false));
      return;
    }
    this.checkLibraryStatus(this.poll, this.contentSurvey, this.document, this.question, this.habit, this.reflection,this.contentScreens)
    mixpanel.track(`In Steps-${this.currentDay}-${this.currentScreenId}`, {'timeSpent': timeSpent})
    
    // Use allScreens array if available, otherwise fallback to screensIds
    if (this.allScreens && this.allScreens.length > 0) {
      this.currentScreenIndex++;
      if (this.currentScreenIndex >= this.allScreens.length) {
        return this.lastScreenAction()
      }
      this.currentScreenId = this.allScreens[this.currentScreenIndex].id;
      console.log('nextScreen (allScreens):', {
        currentScreenIndex: this.currentScreenIndex,
        currentScreenId: this.currentScreenId,
        allScreens: this.allScreens.map(s => s.id)
      });
    } else {
      this.currentScreenIndex++;
      if (this.currentScreenIndex >= this.screensIds?.length) {
        return this.lastScreenAction()
      }
      this.currentScreenId = this.screensIds[this.currentScreenIndex];
      console.log('nextScreen (screensIds):', {
        currentScreenIndex: this.currentScreenIndex,
        currentScreenId: this.currentScreenId,
        screensIds: this.screensIds
      });
    }
    
    this.showCurrentScreen()
    this.appState.set('isRoutineEdited', false)
    if (this.isScreenViewed && this.screensIds[this.currentScreenIndex] === "-loop") {
      this.nextScreen(false, false)
    }
    let activeStepIndex= this.appState.get('currentActiveStepIndex');
    if (this.allowScreenCount && this.currentDay ==scheduledStep && this.dailyStepsArray[this.currentOpenedChapter]?.steps[this.activeStepIndex]?.stepStatus!='Review') {
      this.utilService.setScreenData(this.currentScreenIndex, this.currentDay, this.screensIds)
    }
    if (this.isQuestionCompleted && this.screensIds[this.currentScreenIndex] === "daily-content-screen-question") {
      this.appState.set('isQuestionCompleted', false)
    }
    if (this.screensIds[this.currentScreenIndex] === "daily-content-screen-todo") {
      this.todoRoutines = this.appState.get('todoRoutines')
      this.todoActions = this.appState.get('todoActions')
    }
    let isNewStepUnlocked = this.appState.get('isNewStepUnlocked')
    if (isNewStepUnlocked) {
      this.appState.set('allowScreenCount', true)
      this.appState.set('isNewStepUnlocked', undefined)
    }
    this.showKeyboard()
    this.utilService.stopEmbeddedVideo()
  }

  findCurrentPlatform(){
    const ua = navigator.userAgent.toLowerCase();
    const hasTouch = navigator.maxTouchPoints > 1 || 'ontouchstart' in window;

    // Actual tablets (Android Tablets, iPads)
    const isTablet = /ipad|android(?!.*mobi)|tablet/i.test(ua);

    // Exclude touch laptops (Windows/macOS laptops with touchscreens)
    const isLaptop = hasTouch && !isTablet && /windows|mac os|linux/i.test(ua);
    if(this.platform.is("mobileweb") && this.platform.is("ipad") && (!isLaptop || !this.platform.is('desktop'))){
      return 'web-ipad';
    } else if(this.platform.is("mobileweb") && this.platform.is("tablet") && (!isLaptop || !this.platform.is('desktop'))){
      return 'web-tablet';
    } else if(this.platform.is("mobileweb") && this.platform.is("ios") && !this.platform.is("ipad")){
      return 'web-ios';
    } else if(this.platform.is("mobileweb") && this.platform.is("android") && !this.platform.is("tablet")){
      return 'web-android';
    } else if(this.platform.is("ios") && this.platform.is("mobile")){
      return 'ios';
    } else if(this.platform.is("android") && this.platform.is("mobile")){
      return 'android';
    } else if(!this.isMobile){
      return 'web';
    }
  }

  updateStreaksData() {
    this.streaksInfo = this.appState.get('dailyStreaksInfo');
    if (!this.streaksInfo?.todays_streak) {
      mixpanel.track("Streak data before streaks api call for storing today's streak", {streaksInfo:this.streaksInfo, pathId: this.currentPath?.id})
      this.homeUIService.fetchDailyStreaksInfo(this.currentDay).subscribe((data) => {
         mixpanel.track('Streak completed for today', { todaysStreak: data?.data?.todays_streak,streaksInfo:data?.data, pathId: this.currentPath?.id})
        this.appState.set('isStreaksInfoUpdated', true);
        this.appState.set('updatedStreaksInfo', data?.data);
        this.sessionService.generateStreakWeekDays(data?.data);
      }, (error) => {
        console.log('Error: ', error);
        mixpanel.track('Streak not completed for today', { todaysStreak: this.streaksInfo?.todays_streak, pathId: this.currentPath?.id})
        this.toasterService.warning(this.i18n.t("Error, while storing streaks info!"));
      });
    }
  }

  /**
   * Set when the learner reaches the end-of-step — the only exit that counts as finishing the step.
   * Everything else (closing, leaving) must not report every screen seen, because the backend reads
   * visitedScreens == totalScreens as "step complete".
   */
  /**
   * Where the learner actually was, kept apart from what is REPORTED as progress.
   *
   * Closing on the last screen deliberately reports one screen less (`reserveLastScreen`), because
   * the backend reads visitedScreens == totalScreens as "step complete" and a close is not a
   * completion. Restoring from that same number therefore reopened the step one screen too early.
   * This key carries the true position, so the hold-back stays confined to the progress write.
   */
  private resumeKey(): string {
    const user = this.currentUser ?? this.appState.get('currentUser')
    const path = this.currentPath ?? this.appState.get('currentPath')
    return `Toggle:User:${user?.id}:StepResume:${path?.id}:${this.currentDay}`
  }

  /**
   * Read in ngOnInit: ngDoCheck runs before ngAfterViewInit and rewrites the key from
   * `currentScreenIndex`, which is still 0 on a fresh open — so reading it inside the restore
   * always saw the 0 it had just written. -1 means nothing worth restoring.
   */
  private resumeIndexAtLoad = -1;

  private captureResumeIndex() {
    if (!this.currentDay) { return }
    const saved = localStorage.getItem(this.resumeKey())
    if (saved !== null) { this.resumeIndexAtLoad = +saved }
    // No local record (another device, cleared storage): nothing to correct, so the existing
    // server-side `screensViewed` restore below is left to handle it exactly as it did before.
  }

  /**
   * Is the learner revisiting a step they are already done with, rather than resuming an
   * interrupted one? A review always opens at the first screen.
   *
   * Two proofs, both written by something this flow owns: the end-of-step was seen, or the learner
   * has started the following step. Neither fires for the case the resume key exists for — leaving
   * the ACTIVE step part-way, where the next step is untouched and the end-of-step never ran.
   *
   * Deliberately NOT keyed on `DayCompleted`: updated-home writes that key too, from its own view of
   * which steps are complete, so trusting it here would let the home screen switch off resume.
   */
  private isReviewingFinishedStep(): boolean {
    if (this.hasSeenEndOfStep()) { return true }
    const here = this.resolveStepInHand()
    const own = this.dailyStepsArray?.[here.chapterIndex]?.steps?.[here.stepIndex]?.stepStatus
    const next = this.stepAfter(here.chapterIndex, here.stepIndex)
    return own === 'Review' && next != null && next.stepStatus != null
  }

  /** Where to resume, or -1 when the step should open from the top. */
  private resumeIndexFromLocalProgress(): number {
    if (!this.screensIds?.length) { return -1 }
    // A finished step is reviewed from the top, never resumed part-way.
    if (this.isReviewingFinishedStep()) { return -1 }
    const index = this.resumeIndexAtLoad
    if (!Number.isInteger(index) || index < 0) { return -1 }
    return Math.min(index, this.screensIds.length - 1)
  }

  /** Is this pass through the end-of-step the step's actual completion, rather than a review? */
  completingStepNow = false;

  private reachedEndOfStep = false;

  private leavingBeforeEndOfStep(): boolean { return !this.reachedEndOfStep }

  /** The step after the given one, crossing into the next chapter. Null at the end of the path. */
  private stepAfter(chapterIndex: number, stepIndex: number) {
    const chapters = this.dailyStepsArray ?? []
    const steps = chapters[chapterIndex]?.steps ?? []
    if (stepIndex + 1 < steps.length) { return steps[stepIndex + 1] }
    return chapters[chapterIndex + 1]?.steps?.[0] ?? null
  }

  /** Has the learner been through this step's end-of-step? Written by the weldone screen. */
  private hasSeenEndOfStep(): boolean {
    return localStorage.getItem(
      `Toggle:User:${this.currentUser?.id}:EOSSeen:${this.currentPath?.id}:${this.currentDay}`) === 'yes'
  }

  /**
   * Is this the learner's first time reaching this step's end-of-step?
   *
   * Answered from the NEXT step: completing an end-of-step is what starts the next one, so a next
   * step still untouched means this one was never finished. `stepStatus` cannot answer it, because
   * the backend derives that from visitedScreens vs totalScreens and so reads `Review` as soon as the
   * last screen is SEEN. And they must not have been through it already, or returning replays it.
   */
  private isFirstVisitToEndOfStep(nextStep: any, seenEndOfStepBefore: boolean, ownStatus?: any): boolean {
    if (seenEndOfStepBefore) { return false }
    if (nextStep) { return nextStep.stepStatus === null || nextStep.stepStatus === undefined }
    // Last step of the path: nothing to have started, so fall back to this step.
    return ownStatus == null || ownStatus === 'Resume'
  }

  /**
   * The chapter/step indexes of the step actually in hand, resolved by its position.
   *
   * `currentOpenedChapter`/`activeStepIndex` default to the ACTIVE step and are reassigned from
   * ambient app state, so reviewing an earlier step (prev from the end-of-step) leaves them naming
   * a different step. Falls back to them when the position cannot be matched, so a path without
   * positions behaves exactly as before.
   */
  /**
   * Where a deep link points, or -1 for none and for a target this step does not hold.
   *
   * A deep link wins over every other restore rule, including "a finished step opens at the top":
   * unlocking or recommitting a habit level opens the step that TEACHES that habit, at that screen,
   * and that step is often one the learner finished long ago.
   */
  private deepLinkIndex(): number {
    if (!this.startFromScreen) { return -1 }
    const index = this.screensIds?.indexOf(this.startFromScreen)
    return index === undefined || index === null ? -1 : index
  }

  private resolveStepInHand(): { chapterIndex: number, stepIndex: number } {
    const fallback = { chapterIndex: this.currentOpenedChapter, stepIndex: this.activeStepIndex }
    if (!this.currentDay || !this.dailyStepsArray?.length) { return fallback }
    if (this.dailyStepsArray[this.currentOpenedChapter]?.steps?.[this.activeStepIndex]?.position === this.currentDay) {
      return fallback
    }
    const found = this.currentPath?.findChapterAndStepIndex?.(this.dailyStepsArray, this.currentDay)
    return found ? { chapterIndex: found.chapterIndex, stepIndex: found.stepIndex } : fallback
  }

  /** A restart abandoned part-way is over; otherwise the flag outlives the attempt. */
  private clearAbandonedRestart() {
    this.appState.set('isCurrentStepRestarted', false);
  }

  async lastScreenAction() {
    this.reachedEndOfStep = true;
    this.dailyStepsArray = this.appState.get('DailyStepsData');
    // The step in hand, not whichever step the ambient indexes happen to name.
    const here = this.resolveStepInHand()
    let currentOpenedChapter = here.chapterIndex;
    let activeStepIndex = here.stepIndex
    let scheduledStep = this.appState.get("scheduleDayForCurrentStep");
    this.flag = true;
    console.log("this.allowScreenCount", this.allowScreenCount);
    let stepStatus = this.dailyStepsArray[currentOpenedChapter]?.steps[activeStepIndex]?.stepStatus
    // Decided once and reused below, so the completion call and the first-time view never disagree.
    this.completingStepNow = this.isFirstVisitToEndOfStep(
      this.stepAfter(currentOpenedChapter, activeStepIndex), this.hasSeenEndOfStep(), stepStatus)
    // Which end-of-step shows is a property of the STEP, not of whether it happens to be the
    // scheduled one. `scheduledStep` is a global with many writers and more than one meaning, so
    // while this sat inside that guard the mismatch alone sent a first completion to the review
    // screens.
    if (this.completingStepNow) {
      this.appState.set('showInitialWeldone',true)
    }
    if (this.allowScreenCount && this.currentDay == scheduledStep && this.dailyStepsArray[currentOpenedChapter]?.steps[activeStepIndex]?.stepStatus != 'Review') {
    await  this.utilService.setScreenData(this.currentScreenIndex, this.currentDay, this.screensIds)
     await this.utilService.setScreenCount()
    }
    localStorage.setItem(
      `Toggle:User:${this.currentUser.id}:DayCompleted:${this.currentPath.id}:${this.currentDay}`,
      'yes'
    )

     //commenting 668 frontend change
    // Only a genuine completion reports one. Reviewing a finished step reached here too, because the
    // old guard asked `stepStatus != 'Review'` of the ACTIVE step — unstarted, so never 'Review'.
    //
    // The second clause is the retry: this call is fire-and-forget, so a failed one leaves the step
    // short of 'Review' on the server for good. While the server still does not know the step is
    // done, reaching its end reports it again. A step the server already has stays untouched.
    if(this.completingStepNow || stepStatus !== 'Review'){
      const reqData = {
        user_id: this.currentUser.id,
        path_id: this.currentPath.id,
        step: this.dailyStepsArray[currentOpenedChapter]?.steps[activeStepIndex]?.position,
        step_id: this.dailyStepsArray[currentOpenedChapter]?.steps[activeStepIndex]?.step?.id,
        platform: this.findCurrentPlatform(),
        original_step: this.dailyStepsArray[currentOpenedChapter]?.steps[activeStepIndex]?.originalStep
      };
      this.routineService.endTime(reqData).subscribe( (response) => {
        console.log('put request succesful', response);
        mixpanel.track(` Step ${this.currentDay} is completed`)
      }, (error) => {
        console.log('Error: ', error);
        this.toasterService.warning(this.i18n.t("Error, please check!"));
      });

      this.updateStreaksData();
    }

    localStorage.setItem(`Toggle:User:${this.currentUser.id}:DayUnlockCompleted:${this.currentPath.id}:${this.currentDay}`, 'yes')
    this.appState.set('prevRoutineTime', undefined)
    this.appState.set('prevdays', undefined)
    this.appState.set('prevTimings', undefined)
    if (this.isLastDayCompleted) {
      this.isWeldoneScreenCalled =false;
      if(this.dailyStepsArray?.length < this.scheduledDay){
        const dayCompleted = this.scheduledDay + 1
        localStorage.setItem('stepCompleted',dayCompleted.toString())
      }
      this.sendPathCompletionEmail(this.currentUser.id)
      if ( this.appState.get("hideCloseout")) {
        // this.router.navigate(['/main']);
      this.modalController.dismiss();
      }
      else {
        await this.modalController.dismiss({isCloseout:true});
        this.homeUIService.openDailyStepsComponent(CloseoutSurveyWelcomeComponent,'','web-closeout-welcome-modal');
      }
    } else {
      let isPollIndex;
      this.isAlreadyPresent = undefined
      this.appState.set('isNewStep', true)
      this.isWeldoneScreenCalled = true;
      // let activeStepIndex = this.appState.get('reviewingStepIndex')
      if (this.completingStepNow) {
        this.appState.set('showInitialWeldone',true)
      }
      this.eOSContent()
      const isNpsIndex = (this.stepActionPointInfo as any[])?.findIndex((item) => item?.type === 'nps');
      if (isNpsIndex > -1) {
        this.stepActionPointInfo.splice(isNpsIndex, 1);
        this.eOSNpsData();
      }
      isPollIndex = this.stepActionPointInfo?.findIndex((item) => item?.type === "poll");
      if (isPollIndex > -1) {
        this.stepActionPointInfo.splice(isPollIndex, 1);
        this.eOSPollData();
      }
      else {
        this.appState.set("stepScreenIds", this.stepActionPointInfo);
      }
       this.appState.set('currentStepScreenIds',this.screensIds)
    }
  }

  eOSPollData() {
    let actionPoints =0
    this.currentPath = this.appState.get('currentPath');
    this.multiplePolls = this.filterStepsByContentType('poll');
    this.multiplePolls = this.multiplePolls?.slice()?.sort((a, b) => a?.screenPosition - b?.screenPosition);
    this.multiplePolls?.forEach(item => {
      if (!item) {
        return
      }
      if (item?.screen?.actionPoints != null && !item?.screen?.isCompleted) {
        actionPoints = actionPoints + item?.screen?.actionPoints;
      }
    });
    if (this.multiplePolls && actionPoints!=0) {
      this.stepActionPointInfo.push({ type: 'poll', actionPoints: actionPoints })
    }
    this.appState.set("stepScreenIds", this.stepActionPointInfo);
  }

   eOSContent() {
    let actionPoints =0
    this.currentPath = this.appState.get('currentPath');
    this.contentScreens = this.filterStepsByContentType('content');
    this.contentScreens?.forEach(item => {
      if (!item) {
        return
      }
      if(item?.screen?.actionPoints && item?.screen?.actionPoints>0 && !item?.screen?.isCompleted && (item?.screen?.content?.media?.type =='audio' || item?.screen?.content?.media?.type =='video')){
          actionPoints =actionPoints + item?.screen?.actionPoints
        }
    });
    if (this.contentScreens && actionPoints!=0) {
      this.stepActionPointInfo.push({ type: 'content', actionPoints: actionPoints })
    }
    this.appState.set("stepScreenIds", this.stepActionPointInfo);
  }


  get isLastDayCompleted(): boolean {
    let dailySteps =this.appState.get("DailyStepsData")
    const scheduleDay = +this.appState.get('currentScheduleDay')
    if(this.isMobile) {
      return scheduleDay >= this.lastDayOfContent
    }
    else {
      this.notLastStep =scheduleDay >= this.lastDayOfContent
      return scheduleDay >= this.lastDayOfContent
    }
  }

  /**
   * True once the notification reminder is fully configured: a reminder time AND at least one
   * delivery method (push/login, email, or social). Reads the server-stored pathRegistration
   * live (not the localStorage-backed learningTime field, which can leak across paths) so it
   * reflects a just-confirmed setting and, on cycle 2+, is already true when settings carried
   * over — matching the requirement that the confirmation/calendar Next button activates
   * whenever notifications are set up.
   */
  get notificationSettingsComplete(): boolean {
    const pd: any = this.appState.get('pathRegistration')?.pathData;
    const hasTime = !!pd?.loginReminderTime;
    const hasMethod = !!(pd?.loginReminderEnabled  ||
      pd?.emailReminderEnabled);
    return hasTime && hasMethod;
  }

  filterStepsByContentType(type: ScreenTypes) {
    if (this.currentPath?.kyperChapters?.length > 0) {
      let activeStepScreens = this.dailyStepsArray[this.currentOpenedChapter]?.steps[this.activeStepIndex]
      const screens = activeStepScreens?.screens;
      if (type && screens?.length > 0) {
        // Return only screens matching the screenType
        return screens
          ?.filter(screen => screen?.screenType === type)
          .map(screen => ({
            screen: screen?.screenContents,
            step: activeStepScreens?.position,
            stepId: activeStepScreens?.step?.id,
            screenId: screen?.id,
            screenContentId: screen?.screenContents?.id,
            screenPosition: screen?.position,
            assets:screen?.assets
          }));
      }
    }
    return type == 'content' || type == 'poll' || type =='notifications' ? [] : null;
  }

private createScreenBlock(condition: boolean, order: number, setter: Function) {
  return condition && setter ? { order, screenSetter: setter } : null;
}

// Get current screen based on currentScreenIndex from flattened allScreens array
getCurrentScreen(): any {
  if (this.allScreens && this.allScreens.length > 0 && this.currentScreenIndex >= 0 && this.currentScreenIndex < this.allScreens.length) {

    this.fetchContainerBlurClassStatus(this.allScreens[this.currentScreenIndex]?.content?.screen)
    return this.allScreens[this.currentScreenIndex];
  }
  return null;
}

shouldShowScreen(screenId: string): boolean {
  // if (screenId === 'daily-content-screen-instruction') {
  //   const key = `dailyContentInstructionShown:${this.currentPath?.id}:${this.currentDay}`;
  //   const shown = !!localStorage.getItem(key);

  //   if (this.allScreens && this.allScreens.length > 0) {
  //     const currentScreen = this.getCurrentScreen();
  //     // show only when instruction is the current screen and it hasn't been shown before
  //     if (currentScreen?.id === screenId && !shown) {
  //       try { localStorage.setItem(key, 'true'); } catch (e) { /* ignore storage errors */ }
  //       return true;
  //     }
  //     return false;
  //   } else {
  //     // fallback: when using screensEnabled and on the first screen index
  //     if (this.screensEnabled[screenId] && this.currentScreenIndex === 0 && !shown) {
  //       try { localStorage.setItem(key, 'true'); } catch (e) { /* ignore storage errors */ }
  //       return true;
  //     }
  //     return false;
  //   }
    // }

  if (this.allScreens && this.allScreens.length > 0) {
    // When allScreens is initialized, show only the current screen
    const currentScreen = this.getCurrentScreen();
    return currentScreen?.id === screenId;
  } else {
    // Fallback to screensEnabled for backward compatibility
    return this.screensEnabled[screenId];
  }
}

private initializeAllScreens() {
  console.log('initializeAllScreens called', {
    contentScreens: (this.contentScreens || []).length,
    multiplePolls: (this.multiplePolls || []).length,
    contentSurvey: !!this.contentSurvey,
    document: !!this.document,
    question: !!this.question,
    habit: !!this.habit,
    reflection: !!this.reflection
  });
  const screens = [];

  // Add instruction screen
  if (this.screensIds?.includes('daily-content-screen-instruction')) {
    screens.push({
      id: 'daily-content-screen-instruction',
      type: 'instruction',
      screenOrder: 0,
      content: null
    });
  }

  // Add content screens
  if (this.contentScreens && this.contentScreens.length > 0) {
    this.contentScreens.forEach((screen, i) => {
      const screenId = 'daily-content-screen-intro-' + screen?.screen?.id;
      if (this.screensIds?.includes(screenId)) {
        screens.push({
          id: screenId,
          type: 'content',
          screenOrder: screen?.screenPosition || 1000 + i,
          content: screen
        });
      }
    });
  }

  // Add miniHtml app screen

  if (this.htmlMiniApp && this.screensIds?.includes('daily-content-screen-mini-app')) {
    screens.push({
      id: 'daily-content-screen-mini-app',
      type: 'miniApp',
      screenOrder: this.htmlMiniApp?.screenPosition || 9000,
      content: this.htmlMiniApp
    });
  }

  // Add poll screens (multiple)
  if (this.multiplePolls && this.multiplePolls.length > 0) {
    this.multiplePolls.forEach((poll, i) => {
      const screenId = 'daily-content-screen-poll-' + poll?.screen?.id;
      if (this.screensIds?.includes(screenId)) {
        screens.push({
          id: screenId,
          type: 'poll',
          pollType: poll?.screen?.contentType, // 'mcq', 'linear', 'forcerank'
          screenOrder: poll?.screenPosition || 2000 + i,
          content: poll
        });
      }
    });
  }

  // Add survey screen
  if (this.contentSurvey && this.screensIds?.includes('daily-content-screen-survey')) {
    screens.push({
      id: 'daily-content-screen-survey',
      type: 'assessment',
      screenOrder: this.contentSurvey?.screenPosition || 3000,
      content: this.contentSurvey
    });
  }
  const questionScreenIds = ['daily-content-screen-question', 'daily-content-screen-question-comments'];
  questionScreenIds.forEach((screenId, i) => {
    if (this.screensIds?.includes(screenId)) {
      screens.push({
        id: screenId,
        type: 'social',
        screenOrder: this.question?.screenPosition || 4000 + i,
        content: this.question
      });
    }
  });

  // Add action screen
  if (this.habit && this.screensIds?.includes('daily-content-screen-habit')) {
    screens.push({
      id: 'daily-content-screen-habit',
      type: 'action',
      screenOrder: this.habit?.screenPosition || 5000,
      content: this.habit
    });
  }

  // Add reflection screen
  if (this.reflection && this.screensIds?.includes('daily-content-screen-reflection')) {
    screens.push({
      id: 'daily-content-screen-reflection',
      type: 'reflection',
      screenOrder: this.reflection?.screenPosition || 6000,
      content: this.reflection
    });
  }
   const isAnyLevelCompleted = this.routine?.screen?.content?.habits?.some(
    l => l?.isHabitUnlocked || l?.isHabitCompleted
  ) ||this.routine?.screen?.isCompleted;
   const showRoutineScreens =
    (!isAnyLevelCompleted) ||
    this.isRoutineEdited ||
    this.showUpdatedScreens;

  // Add routine/habit screens
  const routineScreenIds = ['daily-content-screen-routine', 'daily-content-screen-routine-levels', 'daily-content-screen-routine-sub-level', 'daily-content-screen-habit-loop', 'daily-content-screen-meet-cue', 'daily-content-screen-options'];
  routineScreenIds.forEach((screenId, i) => {
    if (this.screensIds?.includes(screenId) && showRoutineScreens) {
      screens.push({
        id: screenId,
        type: 'routine',
        screenOrder: this.routine?.screenPosition || 7000 + i,
        content: this.routine
      });
    }
  });

  // Add onboarding screens (each with separate screen order)
  const onboardingScreenOrders = {
    'daily-content-screen-learning-settings': this.learningScreenData?.length>0?this.learningScreenData[0]?.screenPosition: 8000,
    'daily-content-screen-learning-settings-confirmation': this.learningScreenData?.length>1?this.learningScreenData[0]?.screenPosition : 8100,
    'daily-content-screen-learning-settings-confirmation-calender':this.learningScreenData?.length>0?this.learningScreenData[1]?.screenPosition : 8200,
    'daily-content-screen-manager-email': this.managerEmailScreenData?.screenPosition || 8300,
    'daily-content-screen-accountability-email': this.accountabilityEmailData?.screenPosition || 8400,
    'daily-content-screen-profile-photo': this.profileScreenData?.screenPosition || 8500,
    'daily-content-screen-path-personalization': this.pathPersonalizationData?.screenPosition || 8600
  };
  
  Object.entries(onboardingScreenOrders).forEach(([screenId, screenOrder]) => {
    if (this.screensIds?.includes(screenId)) {
      screens.push({
        id: screenId,
        type: 'onboardingSteps',
        screenOrder: screenOrder,
        content: this.fetchOnboardingContent(screenId)
      });
    }
  });

  // Add NPS screen
  if (this.npsScreenData && (this.screensIds as string[])?.includes('daily-content-screen-nps')) {
    screens.push({
      id: 'daily-content-screen-nps',
      type: 'nps',
      screenOrder: this.npsScreenData?.screenPosition || 9500,
      content: this.npsScreenData
    });
  }

  // Sort by screenOrder
  this.allScreens = screens.sort((a, b) => a.screenOrder - b.screenOrder);
  console.log('allScreens initialized:', this.allScreens);
}

  fetchOnboardingContent(screentype) 
  {
     switch(screentype)
     {
      case 'daily-content-screen-learning-settings':
        return this.learningScreenData[0];
        case 'daily-content-screen-learning-settings-confirmation':
          return this.learningScreenData[1];
        case 'daily-content-screen-learning-settings-confirmation-calender':
          return this.learningScreenData[1];
        case 'daily-content-screen-profile-photo':
          return this.profileScreenData;
        case 'daily-content-screen-path-personalization':
         return this.pathPersonalizationData;
        case 'daily-content-screen-manager-email':
          return this.managerEmailScreenData;
        case 'daily-content-screen-accountability-email':
          return this.accountabilityEmailData;
     }
  }
private reorderScreensFromAllScreens() {
  console.log('reorderScreensFromAllScreens called', { allScreensCount: (this.allScreens || []).length });
  if (!this.allScreens || this.allScreens.length === 0) {
    return;
  }
  const prevEnabled = { ...this.screensEnabled };
  this.screensIds = this.allScreens.map(s => s.id);
  this.screensEnabled = {};
  this.screensIds?.forEach(id => {
    this.screensEnabled[id] = prevEnabled[id] !== undefined ? prevEnabled[id] : true;
  });

  console.log('reordered screensIds from allScreens', this.screensIds, this.screensEnabled);
}

setNewContent() {
  this.poll = this.filterStepsByContentType('poll') ?? [];
  this.contentScreens = this.filterStepsByContentType('content') ?? [];
  this.contentSurvey = this.filterStepsByContentType('assessment')?.[0] ?? null;
  this.question = this.filterStepsByContentType('social')?.[0] ?? null;
  this.habit = this.filterStepsByContentType('action')?.[0] ?? null;
  this.routine = this.filterStepsByContentType('habits')?.[0] ?? null;
  this.reflection = this.filterStepsByContentType('reflection')?.[0] ?? null;
  this.learningScreenData = this.filterStepsByContentType('notifications') ?? [];
  this.managerEmailScreenData = this.filterStepsByContentType('managerEmail')?.[0] ?? null;
  this.profileScreenData = this.filterStepsByContentType('profile')?.[0] ?? null;
  this.htmlMiniApp = this.filterStepsByContentType('miniApp')?.[0] ?? null;
  this.pathPersonalizationData = this.filterStepsByContentType('pathPersonalization')?.[0] ?? null;
  this.accountabilityEmailData = this.filterStepsByContentType('accountabilityPartnerEmail')?.[0] ?? null;
  this.npsScreenData = this.filterStepsByContentType('nps')?.[0] ?? null;
  this.routineScreenImage =this.routine?.assets?.length>0?this.routine?.assets?.filter(media=> media?.assetType =='image'&& media.url&&media?.url?.trim()?.length>0)?.[0]?.url:null
  console.log("polls, cotentSurveys,reflections", this.contentScreens, this.poll, this.contentSurvey, this.question, this.habit, this.routine, this.reflection,this.learningScreenData,this.profileScreenData,this.pathPersonalizationData,this.accountabilityEmailData);
  // --- Habit level completion check ---
   const isAnyLevelCompleted = this.routine?.screen?.content?.habits?.some(
    l => l?.isHabitUnlocked || l?.isHabitCompleted
  ) ||this.routine?.screen?.isCompleted;

  const showRoutineScreens =
    ( !isAnyLevelCompleted) ||
    this.isRoutineEdited ||
    this.showUpdatedScreens;
 const showInstructions= this.currentOpenedChapter<1 && this.activeStepIndex<1;
 //this.dailyStepsArray[0]?.steps[0]?.stepStatus;

  // --- BASE screens ---
  const baseScreens = [
     this.createScreenBlock(showInstructions, 0, () => this.addScreen('daily-content-screen-instruction')),
    this.createScreenBlock(this.contentScreens.length > 0, this.contentScreens[0]?.screenPosition, () => this.setInScreen()),
    this.createScreenBlock(this.htmlMiniApp, this.htmlMiniApp?.screenPosition, () => this.setMiniAppScreen('daily-content-screen-mini-app')),
    this.createScreenBlock(this.poll.length > 0, this.poll[0]?.screenPosition, () => this.setPoll('daily-content-screen-poll')),
    this.createScreenBlock(!!this.contentSurvey, this.contentSurvey?.screenPosition, () => this.setcontentSurvey('daily-content-screen-survey')),
    this.createScreenBlock(!!this.question, this.question?.screenPosition, () => this.setQuestion('daily-content-screen-question')),
    this.createScreenBlock(!!this.habit, this.habit?.screenPosition, () => this.setHabit('daily-content-screen-habit')),
    this.createScreenBlock(!!this.reflection, this.reflection?.screenPosition, () => this.setReflection('daily-content-screen-reflection')),
    this.createScreenBlock(this.learningScreenData?.length > 0, this.learningScreenData[0]?.screenPosition, () => this.setLearningScreen(this.learningScreenData, 'daily-content-screen-learning-settings')),
    this.createScreenBlock(!!this.managerEmailScreenData, this.managerEmailScreenData?.screenPosition, () => this.setManagerScreen(this.managerEmailScreenData,'daily-content-screen-manager-email')),
    this.createScreenBlock(!!this.accountabilityEmailData, this.accountabilityEmailData?.screenPosition, () => this.setAccountabilityManagerScreeen(this.accountabilityEmailData,'daily-content-screen-accountability-email')),
    this.createScreenBlock(!!this.profileScreenData, this.profileScreenData?.screenPosition, () => this.setProfilePhotoScreeen(this.profileScreenData,'daily-content-screen-profile-photo')),
    this.createScreenBlock(!!this.pathPersonalizationData, this.pathPersonalizationData?.screenPosition, () => this.setpathPersonalizationScreen(this.pathPersonalizationData,'daily-content-screen-path-personalization')),
    this.createScreenBlock(!!this.npsScreenData, this.npsScreenData?.screenPosition, () => this.setNpsScreen('daily-content-screen-nps')),
  ];

  // --- HABIT screens ---
  const routineScreens = showRoutineScreens
    ? [
        'daily-content-screen-routine',
        'daily-content-screen-routine-levels',
        'daily-content-screen-routine-sub-level',
        'daily-content-screen-habit-loop',
        'daily-content-screen-meet-cue',
        'daily-content-screen-options',
      ].map(type =>
        this.createScreenBlock(
          !!this.routine,
          this.routine?.screenPosition,
          () => this.setRoutine(type)
        )
      )
    : [];

  // Final merged list (remove nulls)
  const sortableCalls = [...baseScreens, ...routineScreens].filter(x => x);

  // --- SAFE EXECUTION ---
  sortableCalls?.sort((a, b) => a.order - b.order)?.forEach(c => c.screenSetter());

  this.appState.set("stepScreenIds", this.stepActionPointInfo);

  console.log("sortable calls screensIds", this.screensIds, sortableCalls, this.screensEnabled, this.multiplePolls);

  // Initialize flattened allScreens array sorted by screenOrder
  this.initializeAllScreens();

  // If allScreens is initialized, reorder screensIds and screensEnabled
  // to reflect the canonical order defined by allScreens
  if (this.allScreens && this.allScreens.length > 0) {
    this.reorderScreensFromAllScreens();
  }

  if (!this.screensIds?.length) {
    return this.router.navigate(['/main']);
  }
}

  setInScreen() {
    let actionPoints =0;
    if (
      this.contentScreens &&
      this.contentScreens?.length>0
    ) {
      this.contentScreens.forEach((screen, i) => {
        this.addScreen('daily-content-screen-intro-' + screen?.screen?.id)
        if(screen?.screen?.actionPoints && screen?.screen?.actionPoints>0 && !screen?.screen?.isCompleted && (screen?.screen?.content?.media?.type =='audio' || screen?.screen?.content?.media?.type =='video')){
          actionPoints =actionPoints + screen?.screen?.actionPoints
        }
      }
      )
    }
         if(actionPoints>0) {
          this.stepActionPointInfo.push({ type: 'content', actionPoints: actionPoints })
        }
  }

  setMiniAppScreen(id) 
  {
    if (!this.htmlMiniApp) {
      return
    }
    this.addScreen(id);
    let points =this.htmlMiniApp?.screen?.actionPoints
    //  if(points && points>0 ){
    //       this.stepActionPointInfo.push({ type: 'content', actionPoints: points })
    //  }
  }
  removeBackButtonFromFirstScreen() {
    if (!this.screensIds) {
      return
    }
    window.document
      .getElementById('#' + this.screensIds[0])
      .querySelector('.nav-back')
      .remove()
  }

  setContentItem(item, id) {
    if (!item) {
      return
    }
    this.addScreen(id)
  }
  setPoll(id) {
    let actionPoints=0
    this.multiplePolls?.forEach(screen => {
      let item = screen?.screen
      if (!item) {
        return
      }
      if (item?.actionPoints != null && !item?.isCompleted) {
        actionPoints = actionPoints + item?.actionPoints;
      }   
  
      this.addScreen(id + '-' + item.id)
    });
    if (this.multiplePolls && actionPoints>0) {
      this.stepActionPointInfo.push({ type: 'poll', actionPoints: actionPoints })
    }
  }

  setcontentSurvey(contentSurveyScreenId) {
    if (this.contentSurvey) {
      this.stepActionPointInfo.push({type:'survey',actionPoints:this.contentSurvey?.screen?.actionPoints})
    }
    this.setContentItem(this.contentSurvey, contentSurveyScreenId)
  }

  setDocument(documentScreenId) {
    if (this.document) {
      this.stepActionPointInfo.push({type:'document',actionPoints:this.document?.actionPoints})
    }
    this.setContentItem(this.document, documentScreenId)
  }

  setQuestion(questionScreenId) {
    if (this.question) {
      this.stepActionPointInfo.push({type:'question',actionPoints:this.question?.screen?.actionPoints})      
    }
    
    this.setContentItem(this.question, questionScreenId)
    this.addScreen('daily-content-screen-question-comments')
  }

  setHabit(habitScreenId) {
    if (this.habit) {
      this.stepActionPointInfo.push({type:'action',actionPoints:this.habit?.screen?.actionPoints})
    }
    this.setContentItem(this.habit, habitScreenId)
  }

  setRoutine(routineScreenId) {
    if (this.routine) {
      const uniqueItem =this.stepActionPointInfo?.find((item) => item.type === 'routine');
      if (!uniqueItem) {
        this.stepActionPointInfo.push({type:'routine',actionPoints:this.routine?.screen?.actionPoints})
      }
    }
    this.setContentItem(this.routine, routineScreenId)
  }

  setReflection(reflectionScreenId) {
    if (this.reflection) {
      this.stepActionPointInfo.push({type:'reflection',actionPoints:this.reflection?.screen?.actionPoints})
    }
    this.setContentItem(this.reflection, reflectionScreenId)
  }
  setLearningScreen(item,id) {
    // this.setContentItem(this.learningScreenData, learningSettingsId)
    this.pathRegistration = this.appState.get('pathRegistration')
      if (!item || item?.length ==0) {
        return
      }
    if ((!this.learningTime || this.learningTime =='null') || (this.pathRegistration?.pathData?.selectedLearningDay == item[0]?.step && this.pathRegistration?.selectedDayPart!=null) ) {
      this.addScreen(id);
      this.addScreen('daily-content-screen-learning-settings-confirmation-calender')
    }
    else {
    this.addScreen('daily-content-screen-learning-settings-confirmation');
    }
    if ((!this.learningTime || this.learningTime =='null') || (this.pathRegistration?.pathData?.selectedLearningDay == item[0]?.step && this.pathRegistration?.selectedDayPart!=null) ) {
      this.stepActionPointInfo.push({ type: 'notification', actionPoints: item[0]?.screen?.actionPoints })
    }
  }

   setManagerScreen(item,id) {
     if (!item) {
       return
     }
    this.addScreen(id);
    if (!this.currentUser.managerEmails?.length || !this.appState.get("managerEmail")) {
        this.stepActionPointInfo.push({type:'managerEmail',actionPoints:item?.screen?.actionPoints})
    }
   }
  
    setAccountabilityManagerScreeen(item,id) {
      if (!item) {
        return
      }
    this.addScreen(id);
      if (this.currentUser.accountabilityEmails?.length == 0 || (this.appState.get("accountabilityEmails") == undefined || this.onboardLearningComponent?.arrayOfAccountabilyEmails?.length == 0)) {
      
        this.stepActionPointInfo.push({ type: 'accountability', actionPoints: item?.screen?.actionPoints })
      }
  } 
  
  setpathPersonalizationScreen(item, id) {
    if (!item) {
      return
    }
    this.addScreen(id);
    this.stepActionPointInfo.push({ type: 'pathPersonalization', actionPoints: item?.screen?.actionPoints })
  }
  setProfilePhotoScreeen(item,id) {
    if (!item ||(!this.currentUser?.imageUrl?.endsWith("avatar.png") && this.currentUser?.imageUrl !== "nil" && (this.currentUser?.profileUploadedDay !=item?.step && this.currentUser?.['_data']?.['profileUploadedDay'] !=item?.step))) {
      return
    }
    this.addScreen(id);
    this.stepActionPointInfo.push({ type: 'profile', actionPoints: item?.screen?.actionPoints })
  }

  setNpsScreen(id: string) {
    if (!this.npsScreenData) { return; }
    this.addScreen(id);
    if (this.npsScreenData?.screen?.actionPoints != null && !this.npsScreenData?.screen?.isCompleted) {
      (this.stepActionPointInfo as any[]).push({ type: 'nps', actionPoints: this.npsScreenData.screen.actionPoints });
    }
  }

  eOSNpsData() {
    this.npsScreenData = this.filterStepsByContentType('nps')?.[0] ?? null;
    if (this.npsScreenData?.screen?.actionPoints && !this.npsScreenData?.screen?.isCompleted) {
      (this.stepActionPointInfo as any[]).push({ type: 'nps', actionPoints: this.npsScreenData.screen.actionPoints });
    }
  }

  addScreen(id) {
    // check that you have scheduled later or not
    // if you schedule later you will get not see this screen
    // dj - 24 march
    this.screensIds.push(id)
    this.screensEnabled[id] = true
    console.log("tthis.screennEnabled", this.screensEnabled);
  }

  findMatchingTodoAction(): any | null {
    const screenContentId = this.habit?.screen?.id;
    if (!screenContentId) return null;
    const todoActions: any[] = this.appState.get('todoActions') || [];
    const matches = todoActions.filter(a => String(a.screenContentId) === String(screenContentId));
    if (!matches.length) return null;
    return matches.reduce((best, a) => (Number(a.id) > Number(best.id) ? a : best), matches[0]);
  }
  habitConfirm(userId, pathId, habit, onChatbotSuccess?: () => void) {
    let matchedAction =this.findMatchingTodoAction()
    if ( habit?.screen?.userResponse?.userActionCompletion ==true) {
      this.toasterService.warning(this.i18n.t("Micro-action is already completed"));
      return;
    }
    this.isDisabled = true;
    let scheduledStep = this.appState.get("scheduleDayForCurrentStep");
    let activeStepIndex= this.appState.get('currentActiveStepIndex');
    mixpanel.track('In Steps-habit confirm', {'habit': habit, 'userId': userId, 'pathId': pathId})
    if (this.allowScreenCount && this.currentDay ==scheduledStep && this.dailyStepsArray[this.currentOpenedChapter]?.steps[this.activeStepIndex]?.stepStatus!='Review') {
      this.utilService.setScreenData(this.currentScreenIndex, this.currentDay, this.screensIds)
    }
    var isHabitComplete =  habit?.screen?.userResponse?.userActionCompletion && matchedAction?.userActionCompletion
    let input = {
      step_id:habit.stepId,
      screen_id:habit.screenId,
      screen_content_id:habit.screenContentId,
      user_action_completion:true,
      // action_id: matchedAction?.id,
      // user_action_scheduled_later:false,
      action_date_time:this.kyperApiService.formatDate()
     }
    try {
      this.kyperApiService.schedule_commit_action_kyper(input).subscribe(res => {
        // LUMBA-1344
        this.isDisabled = false;
        if (!habit?.screen?.userResponse) {
          habit.screen.userResponse = {};
        }
        this.habit.screen.userResponse.userActionCompletion= res?.data?.userActionCompletion
        this.habit.screen.userResponse.userActionScheduledLater = res?.data?.userActionScheduledLater
        // Persist into DailyStepsData + currentPath so completion survives an in-step close/reopen.
        this.appState.persistScreenContent({ userResponse: this.habit.screen.userResponse }, { screenContentId: this.habit?.screenContentId });
        this.toasterService.success(this.i18n.t("Micro-action completed in To-Do List"));
        onChatbotSuccess?.();
        this.cdRef.detectChanges()

    try {
      if (this.currentPath.enabledAttributes?.feedback && !isHabitComplete) {
        this.initModal(habit)
        if (this.isCommented) {
          this.nextScreen()
        }
      } else {
          this.getActions(this.currentPath.id)
          this.nextScreen()
      }
    } catch (o_O) {
      console.log(o_O);
       this.isDisabled = false;
      this.nextScreen()
    }
      },
        (err) => {
        this.isDisabled = false;
      })
    } catch (o_0) {
       this.isDisabled = false;
      console.log('Errors ', o_0)
    }

  }

  async habitScheduleLater(onChatbotSuccess?: () => void) {
    let matchedAction =this.findMatchingTodoAction()
    if (this.habit?.screen?.userResponse?.userActionCompletion ==true) {
      this.toasterService.warning(this.i18n.t("Micro-action is already completed"));
      return;
    }
    let scheduledStep = this.appState.get("scheduleDayForCurrentStep");
    let activeStepIndex= this.appState.get('currentActiveStepIndex');
    let posts, docLink;
    // this.habit?.documents?.forEach((doc)=>{
    //   if(doc?.id == this.habit?.casualDocumentId) {
    //     posts =doc;
    //   }
    // })
    // let doc = this.appState.get('singleDocument');
    // if(posts?.id == doc?.id) {
    //   posts =this.appState.get('singleDocument')
    // }
    posts =this.habit?.screen?.content
    this.appState.set('singleDocument', posts?.toolLink)
    docLink= posts?.editedDocumentUrl?posts?.editedDocumentUrl:posts?.toolLink;
    mixpanel.track('In Steps-habit schedule later', {'value':'commit'})
    if (this.allowScreenCount && this.currentDay ==scheduledStep && this.dailyStepsArray[this.currentOpenedChapter]?.steps[this.activeStepIndex]?.stepStatus!='Review') {
      this.utilService.setScreenData(this.currentScreenIndex, this.currentDay, this.screensIds)
    }

    const calendarWording = this.actionWordingForCalendar();
    this.prepareCalendarParams(calendarWording.title, this.routineService.innerHtmlToMobileAction(calendarWording.text,docLink))

    if (this.hasNativeCalendar) {
      this.appState.set('scheduledHabitId', this.habit?.screenContentId);
      this.createCalendarEvent()
      this.nextScreen()
    } else {
      this.calendarParams.notes = this.routineService.innerHtmlToWebAction(calendarWording.text,docLink)

      this.homeService.setCalendarData(this.calendarParams)
    
      const modal = await this.modalController.create({
        component: AlertWebactionCalendarComponent,
        animated: this.sessionService.isTabletDevice()? true: false,
        cssClass: this.isMobile?'custom-modal-size':'web-action-calender-modal',
       
      });
       await modal.present() 
       modal.onDidDismiss().then(()=>{
        // this.toasterService.success(this.i18n.t("Micro-action added to To-Do List"));
        //this.nextScreen();
       });
      
    }

    if (this.habit?.screen?.userResponse?.userActionScheduledLater && matchedAction?.userActionCompletion && this.isMobile) {
      // set schedule later yes sometime when button not get clicked - 24 march - d
      // localStorage.setItem(`Toggle:User:${this.currentUser.id}:HabitScheduled:${this.yesterdayHabit.id}`, 'yes')
      this.nextScreen()
      return false
    }
    // this.habitService.scheduleLater(this.habit.id).subscribe(res => {
        let input = {
      step_id:this.habit.stepId,
      screen_id:this.habit.screenId,
      screen_content_id:this.habit.screenContentId,
      // user_action_completion:false,
      user_action_scheduled_later:true,
      // action_id: matchedAction?.id,
      action_date_time:this.kyperApiService.formatDate()
     }
    this.kyperApiService.schedule_commit_action_kyper(input).subscribe(res => {
      if (!this.habit.screen.userResponse) {
        this.habit.screen.userResponse = {};
      }
      this.habit.screen.userResponse.userActionCompletion= res?.data?.userActionCompletion
      this.habit.screen.userResponse.userActionScheduledLater = res?.data?.userActionScheduledLater
      // Persist into DailyStepsData + currentPath so completion survives an in-step close/reopen.
      this.appState.persistScreenContent({ userResponse: this.habit.screen.userResponse }, { screenContentId: this.habit?.screenContentId });
      this.toasterService.success(this.i18n.t("Micro-action added to To-Do List"));
      this.getActions(this.currentPath.id)  
      onChatbotSuccess?.();
      this.cdRef.detectChanges()
    });

  }

  ngOnInit() {
    this.captureResumeIndex()
    this.microActionSub = this.microActionStateService.actionState$.subscribe(state => {
      this.chatbotEngaged = state?.engaged === true;
    });
    this.homeUIService.clearPendingChaptersOrder();
    this.isMobileWeb = this.appState.get('MobileWeb')
    this.isMobileWebIos = this.appState.get('MobileWebIos');
    console.log("this.isMobileWeb value", this.isMobileWeb);
    this.dailyStepsArray = this.appState.get("DailyStepsData");
    this.activeChapterIndex = this.appState.get('currentActiveChapter')
    this.activeStepIndex= this.appState.get('reviewingStepIndex')
    if(this.appState.get('IsOptionSelected')) {
      this.showAnimation =true
    }
    this.colorArray = this.utilService.convertToArray()
    this.IsOptionSelected = this.appState.get('IsOptionSelected');
    this.browserRefresh = browserRefresh;
    if(this.browserRefresh){
       this.toDos =JSON.parse(localStorage.getItem('toDosWhenRefreshed'));
       this.appState.set('toDos', this.toDos);
  
    this.allowScreenCount =true;
    let screenStatus =JSON.parse(localStorage.getItem('screenStatus'));
    this.appState.set('screenStatus', screenStatus);
      this.appState.set('allowScreenCount',true);

      if (this.appState.get('routine_schedule_day')) {
        this.appState.set('routine_schedule_day', null)
      }
    }
    this.unCheckedLevels = this.appState.get('unCheckedLevels')
    if(this.unCheckedLevels){
      function getUnique(arr) {
        const unique = arr.filter((id,index)=>{
          return arr.indexOf(id)===index
        })
        return unique;
      }

      let finalUncheckedLevels = []
      finalUncheckedLevels = getUnique(this.unCheckedLevels) 
      finalUncheckedLevels =[...new Set(finalUncheckedLevels)];
      finalUncheckedLevels?.forEach(unCheckedLevel => {
      this.routine?.screen?.content?.habits?.forEach(routineLevel => {
       
          if ( unCheckedLevel.id === routineLevel.id ) {
            let originalIndex = this.routine?.screen?.content?.habits?.findIndex(item => item.id === unCheckedLevel.id);
            //this.routine.levels.splice(originalIndex, 1)
            this.routine.screen.content.habits[originalIndex].enabled =false
            this.cdRef.detectChanges()
          }
        });
      })
    }

  }
  
  innerHtmlToWebAction(habit: string) {
    var arrayOfUrls = []
    var divHabitData = document.createElement("DIV");
    divHabitData.innerHTML = habit;
    let cleanText = divHabitData.innerText;

    var uri_pattern = /\b((?:[a-z][\w-]+:(?:\/{1,3}|[a-z0-9%])|www\d{0,3}[.]|[a-z0-9.\-]+[.][a-z]{2,4}\/)(?:[^\s()<>]+|\(([^\s()<>]+|(\([^\s()<>]+\)))*\))+(?:\(([^\s()<>]+|(\([^\s()<>]+\)))*\)|[^\s`!()\[\]{};:'".,<>?«»“”‘’]))/ig;
    arrayOfUrls = habit.match(uri_pattern);
    return this.calendarCopy.microActionNotes(cleanText);
  }

  /**
   * The wording for the calendar entry: the customised action where the learner made one, otherwise
   * the step's own. The customisation is kept in its own fields so that rendering the step — here
   * and everywhere else holding this screen content — still shows the action as written.
   */
  private actionWordingForCalendar(): { title: any; text: any } {
    const content: any = this.habit?.screen?.content || {};
    return {
      title: content?.customizedTitle || content?.title,
      text: content?.customizedText || content?.text,
    };
  }

  prepareCalendarParams(title: any, msg: String, routinelen: any = null, eventlen: string = null) {
    const start = moment(new Date(), 'HH:mm')
    const end = moment(new Date(), 'HH:mm').add(10, 'minute')
    var titleOfEvent = "Daily Learning Reminder"

    if (this.currentPath.names && this.currentPath.names.titleOfEvent) {
      titleOfEvent = this.currentPath.names.titleOfEvent;
    } else {
      titleOfEvent = "Daily Learning Reminder"
    }

    this.calendarParams = {
      startDate: start.toDate(),
      endDate: end.toDate(),
      title: title, //updated title
      eventLocation: '',
      notes: msg,
      endEventTime: routinelen,
      frequency: eventlen
    }
  }

  createCalendarEvent() {
    const success = function (message) { console.log('Success: ' + JSON.stringify(message)) }
    const error = function (message) { console.error('Error: ' + message) }

    // create an event interactively
    const w: any = window
    const calOptions = w.plugins.calendar.getCalendarOptions()
    const calendarList = w.plugins.calendar.listCalendars(success, error);

    const daysCount = this.currentPath.lastDayOfContent() * 1.5 // LUMBA-1399
    // calOptions.recurrence = 'daily' // supported are: daily, weekly, monthly, yearly
    calOptions.recurrenceInterval = 1
    calOptions.firstReminderMinutes = 0
    calOptions.recurrenceEndDate = moment(new Date(), 'HH:mm').add(daysCount, 'day').toDate()

    this.calendarService.scheduleEvents(
      this.calendarParams.title,
      this.calendarParams.eventLocation,
      this.calendarParams.notes,
      this.calendarParams.startDate,
      this.calendarParams.endDate,
      calOptions,
      success,
      error
    );
  }

  @HostListener('click', ['$event'])
  onLinkClick(e) {

    if (e.target.tagName.toLowerCase() === 'a' && e.target.target === '_blank') {
      if (this.cordovaService.onCordova) {

        e.stopPropagation()
        e.preventDefault()
        this.cordovaService.openLinkInBrowser(e.target.href)
      } else {

        window.open(e.target.href, '_blank')
      }
    }
  }
  refresh() {
    return new Promise(resolve => {
      this.appState.refreshMainComponent.emit()
      setTimeout(resolve, 0)
    })
  }

  onScroll(event: Event) {
    var offset = (event.target as HTMLElement).scrollTop
    if (offset > 60) {
      this.isScrolledBottom = true
    } else {
      this.isScrolledBottom = false
    }
  }

  receiveScale($dataEvent,i) {
    this.scaleData = $dataEvent.scaleValue;
    this.pathAverage = $dataEvent.pathAverage;
    if (this.scaleData && $dataEvent.question?.screen?.content?.ptype == 'linear') {
      // this.setScale($dataEvent.question, $dataEvent.higherScale)
       let pollObj = {
            poll: $dataEvent.question,
            pollIndex: $dataEvent.question.startDay - 1
          }
          this.blurCard(true,this.scaleData+"/"+$dataEvent.higherScale,this.pathAverage,pollObj,i)
          // this.appState.updateAcrossSteps(this.appState.get('DailyStepsData'),'polls', poll.id, { isCompleted: true })
          const index = this.multiplePolls.findIndex(item => item?.screenContentId === $dataEvent.question?.screenContentId);
          if (index !== -1) {
            this.multiplePolls[index].screen.content.isCompleted = true;
          }
          this.cdRef.detectChanges()
    }
  }

  saveQuestionType(poll) {
    
      this.nextScreen()
  }

  showImInScreen() {
    this.routineSkipped = false
    this.isImInCompleted = true
    mixpanel.track("In Steps-Habit-isImInCompleted", {'Habit-isImInCompleted': true})
    this.appState.set('indexOfLevel', 0)
    this.appState.set('isImInCompleted', true)
    this.appState.set('isRoutineEdited', false)
    this.nextScreen()
  }

  setScale(poll,higherScale?) {
    const requestData = {
      step_id:poll?.stepId,
      screen_id:poll?.screenId,
      screen_content_id: poll?.screenContentId,
      linear_scale_rating: this.scaleData
    }

    if (requestData) {
      // this.spinnerService.on()
      this.pollService.savePollAnswersforKyper(requestData).subscribe(
        (response) => {
          // this.spinnerService.off()
          this.responseData = response.data
          // for (let linear of this.responseData ) {
            this.pathAverage = this.responseData?.pathAverage+'/'+higherScale;
          // }
          let pollObj = {
            poll: poll,
            pollIndex: poll.startDay - 1
          }
          this.blurCard(true,this.scaleData+"/"+higherScale,this.pathAverage,pollObj)
          this.appState.set('rankOptionData', response.data)
          // this.appState.updateAcrossSteps(this.appState.get('DailyStepsData'),'polls', poll.id, { isCompleted: true })
          const index = this.multiplePolls.findIndex(item => item?.screenContentId === poll?.screenContentId);
          if (index !== -1) {
            this.multiplePolls[index].screen.content.isCompleted = true;
          }
          this.cdRef.detectChanges()
        },
        (error) => {
          // this.spinnerService.off()
          this.tostrService.error(this.i18n.t("Server or connection issue. Please check your internet connection."))
        }
      )
    }
  }

  makeRoutineData(makeCommitment) {
     this.appState.set('commitData',`${makeCommitment},${this.selectedCueOption},${this.typeValue}`)
    localStorage.setItem('commitData', `${makeCommitment},${this.selectedCueOption},${this.typeValue}`)
    
    this.appState.set('makeCommitment',makeCommitment)
    localStorage.setItem('makeCommitment', makeCommitment)
     this.getLocalRoutineData()
      if (this.makeCommitment === 'no') {
        this.isEventCreated = true
      }
  }

  selectCueOption(button,routine,level) {
    this.appState.set('changeCue', false)
    this.selectedCueOption = button
    this.appState.set('makeCommitment','yes')
    if (this.selectedCueOption === 'Day(s) & time') {
      this.appState.set('commitData',null)
      localStorage.setItem('commitData', null)
      localStorage.setItem('makeCommitment', 'yes')
      this.typeValue = undefined
      this.openRoutineCalendar(false,this.subRoutineAnswer,routine,level)
    }
    else {
      this.nextScreen()
    } 
  }

  getTypeValue($event) {
    this.typeValue = $event
  }

  getCommitDay($event) {
    this.routineDay = $event
  }

  getCommitTime($event) {
    this.routineTime = $event
  }

  getactivityCueData($event) {
    this.activityCueTime = $event
    localStorage.setItem('activityCueTime', this.activityCueTime)
    this.cdRef.detectChanges()
  }

  checkHabitLoop() {
    this.nextScreen()
  }

  getLocalRoutineData() {
    var localCommitData = localStorage.getItem('commitData')
    var appStateCommitData = this.appState.get('commitData')
    if (localCommitData) {
      this.localRoutineData = localCommitData
      var type = this.localRoutineData.split(',')
      this.commitType = type[1]
      this.makeCommitment = type[0]
    } else {
      this.localRoutineData = appStateCommitData
    }

    var localMakeCommitment = localStorage.getItem('makeCommitment')
    var localActivityCueTime = localStorage.getItem('activityCueTime')
    var appStateMakeCommitment = this.appState.get('makeCommitment')
    var appStateActivityCueTime = this.appState.get('activityCueTime')
    if (localMakeCommitment && localActivityCueTime) {
      this.makeCommitment = localMakeCommitment
      this.activityCueTime = localActivityCueTime
    } else {
      this.makeCommitment = appStateMakeCommitment
      this.activityCueTime = appStateActivityCueTime
    }
  }

  async openRoutineCalendar(isSingleEvent: boolean, subRoutineAnswer: any, routine: any, level: any) {
    if (!this.commitType) { this.commitType = 'dayTime' }
    var routineTime = this.appState.get('routineTime')
    var routineDay = this.appState.get('selectedDate')
    if (!routineTime) { routineTime = '' }
    if (!routineDay) { routineDay = '' }
    if (!this.activityCueTime) { this.activityCueTime = '' }
    if (this.commitType === 'Activity' && !this.activityCueTime) { this.activityCueTime = 'before' }

    var data = {
      text: level.text,
      title: level?.title,
      routineAnswer: subRoutineAnswer,
      level: level,
      isSingleEvent: isSingleEvent,
      backTo: this.backTo,
      typeValue: this.typeValue,
      activityCueTime: this.activityCueTime,
      selectedCueOption: this.selectedCueOption,
      commitType: this.commitType,
      makeCommitment: this.makeCommitment
    }
    this.appState.set("routineCalendarData", data)
  const modal = await this.modalController.create ({
    component: RoutineCalendarComponent,
    animated:false,
    cssClass:this.homeUIService.isDark()?'dark-theme web-action-calender-modal routine-cal':' light-theme web-action-calender-modal routine-cal',
    //backdropDismiss:false
  })
   await modal.present()
   modal.onDidDismiss().then(async ()=>{
    if (!this.commitType) { this.commitType = 'dayTime' }
      var routineTime = this.appState.get('routineTime')
      var routineDay = this.appState.get('selectedDate')
      if (!routineTime) { routineTime = '' }
      if (!routineDay) { routineDay = '' }
      if (!this.activityCueTime) { this.activityCueTime = '' }
      if (this.commitType === 'Activity' && !this.activityCueTime) { this.activityCueTime = 'before' }
      var differentTimes = this.appState.get('differentTimes')
     var differentDays = this.appState.get('differentDays')
     if (differentTimes) {
       differentTimes = this.routinev2Service.formatTimeForFrontEnd(differentTimes);
     }
     let atTransWord =this.i18n.t("at")
      if (differentDays && differentDays?.length>0) {
        this.dayTimeArray = differentDays.map(function (x, i) {
          return x + " " +atTransWord+ " "  + differentTimes[i]
        })

        this.subRoutineAnswer = this.routinev2Service.createCommitEvent(routine, level, this.typeValue,
          this.activityCueTime,
          differentTimes, differentDays, this.commitType, this.makeCommitment, this.i18n.t("on") + " " + this.dayTimeArray.join(', '))
      } else {
       if (this.makeCommitment === 'yes') {
        differentDays = ['Monday', ' Tuesday', ' Wednesday', ' Thursday', ' Friday', ' Saturday', ' Sunday'];
        this.dayTimeArray = this.i18n.t("every day at")+ " " + differentTimes
        this.subRoutineAnswer = this.routinev2Service.createCommitEvent(routine, level, this.typeValue, this.activityCueTime, differentTimes, differentDays, this.commitType, this.makeCommitment, this.dayTimeArray)
      } else if (this.makeCommitment === 'no') {
        differentDays = [];
        this.dayTimeArray = [];
        this.subRoutineAnswer = this.routinev2Service.createCommitEvent(routine, level, this.typeValue, this.activityCueTime, differentTimes, differentDays, this.commitType, this.makeCommitment, this.dayTimeArray)
      }
      }

      if (differentTimes?.length >= 1) {
        const alert = await this.alertController.create({      
          subHeader: this.i18n.t("My commitment"),
          message: this.subRoutineAnswer,
          cssClass: this.homeUIService.isDark() ? 'dark-theme alertBackdrop' : 'light-theme alertBackdrop',
          buttons: [
            {
              text: this.i18n.t("Edit"),
              handler: async () => {
                this.appState.set('dayTimeArray', this.dayTimeArray)
                this.appState.set('isTimeEdited', true)
                isSingleEvent= this.appState.get("routineCalendarData")?.isSingleEvent
                this.openRoutineCalendar(isSingleEvent, this.subRoutineAnswer, routine, level)
              },
              role: 'cancel',
            },
            {
              text: this.i18n.t("Commit"),
              cssClass: 'custom-alert',
              handler:(result)=>{
                this.makeRoutine(routine, level)
              },
             
            },
            
          ]  
         });
      
        await alert.present();

      }

    })
  }

  closeUnlockModal() {
    this.appState.set('isLevelCommited',undefined);
    this.modalController.dismiss();
  }

  makeRoutine(routine: any, level: any) {
    var routineTime = this.appState.get('routineTime')
    var routineDay = this.appState.get('selectedDate')
    if (!routineTime) { routineTime = '' }
    if (!routineDay) { routineDay = '' }
    if (!this.commitType) { this.commitType = 'dayTime' }
    if (!this.typeValue) { this.typeValue = '' }
    if (!this.activityCueTime) { this.activityCueTime = '' }
    if (this.commitType === 'Activity' && !this.activityCueTime) { this.activityCueTime = 'before' }
    var differentTimes = this.appState.get('differentTimes')
    var differentDays = this.appState.get('differentDays')
    if (differentTimes) {
      differentTimes?.forEach(element => {
        const date = moment().format('YYYY/MM/DD')
        const time = element;
        const timeAndDate = moment(date + ' ' + time);
        timeAndDate.format('YYYY/MM/DD hh:mm A')
        let newUtcDate = moment(timeAndDate).utc().format('hh:mm A')
        this.selectedTimings.push(newUtcDate)
      });
      differentTimes = this.routinev2Service.formatTimeForFrontEnd(differentTimes);
    }
    if (this.commitType === 'dayTime') { this.makeCommitment = 'yes' }
    let atTransWord =this.i18n.t("at")
    if (differentDays && differentDays?.length>0) {
      this.dayTimeArray = differentDays.map(function (x, i) {
        return x + " " +atTransWord+ " "  + differentTimes[i]
      })
      this.subRoutineAnswer = this.routinev2Service.createCommitEvent(routine, level, this.typeValue, this.activityCueTime, differentTimes, differentDays, this.commitType, this.makeCommitment, this.i18n.t("on") + " " + this.dayTimeArray)
    } else {
      if (this.makeCommitment === 'yes') {
        differentDays = ['Monday', ' Tuesday', ' Wednesday', ' Thursday', ' Friday', ' Saturday', ' Sunday'];
        this.dayTimeArray = this.i18n.t("every day at")+ " " + differentTimes
        this.subRoutineAnswer = this.routinev2Service.createCommitEvent(routine, level, this.typeValue, this.activityCueTime, differentTimes, differentDays, this.commitType, this.makeCommitment, this.dayTimeArray)
      } else if (this.makeCommitment === 'no') {
        differentDays = [];
        this.dayTimeArray = [];
        this.subRoutineAnswer = this.routinev2Service.createCommitEvent(routine, level, this.typeValue, this.activityCueTime, differentTimes, differentDays, this.commitType, this.makeCommitment, this.dayTimeArray)
      }
    }

    this.selectedDates = this.appState.get("multipleDates") 
    let convertedDates = []
    if (this.selectedDates) {
      this.selectedDates?.forEach(element => {
        let newUtcDate = moment(element).toDate()  
        convertedDates.push(newUtcDate.toString())      
      });
    } 
    let levelsArray = this.sessionService.getSelectedLevels()
    levelsArray = [...new Set(levelsArray)]
    
    let combinedDateTime = []
    if (convertedDates) {
      combinedDateTime = this.combineDateAndTime(convertedDates, this.selectedTimings);
    }

console.log(combinedDateTime);
     let payload = {
      screen_id: this.routine?.screenId,
      step_id: this.routine?.stepId,
      habit_cue_type: this.commitType,
      habit_cue_value: this.typeValue,
      is_habit_unlocked: true,
      is_habit_opted: true,
      habit_group_id: this.routine?.screenContentId,
      habit_id: level.id,
      selected_habit_ids: levelsArray,
      habit_time: this.selectedTimings,
      habit_activity_time: this.activityCueTime,
      commitment_statement: this.subRoutineAnswer,
      habit_different_date_time:combinedDateTime
     }
    console.log("payload", payload);
    this.routinev2Service.kyperComitRoutine(payload).subscribe(
        async (response) => {
           this.appState.set('levelsOrderPayload', undefined)
            this.appState.set('isLevelsReshuffled', undefined)
          this.appState.set('isLevelClosedBeforeCommit',null)
          this.homeUIService.appendRepsOnreoptLevel(routine, level);
          this.appState.set('isScreenViewed', true)
          this.appState.set('prevRoutineTime', this.appState.get('routineTime'))
          this.appState.set('prevdays', this.appState.get('differentDays'))
          this.appState.set('prevTimings', this.appState.get('differentTimes'))
          this.selectedTimings = []
          this.dayTimeArray = []
          localStorage.removeItem(
            `Toggle:Day:${this.currentDay}:LevelNumber:${this.levelId + 1}:true`
          )

          var levelSaveData = {
            levelId: this.levelId,
            currentDay: this.currentDay
          }
          this.appState.set('levelSaveData', levelSaveData)

        level.isCompleted = true
        level.isHabitUnlocked=true
          this.appState.set('levelId', this.levelId)
          this.levelId = this.appState.get('levelId')
           this.kyperApiService.getHabits(this.currentPath.id)
           
          const modal = await this.modalController.create({
            component: AlertRoutineAnimComponent,
            componentProps: {level: level},
            backdropDismiss: false,
            cssClass:this.homeUIService.isDark() ? 'dark-theme web-action-calender-modal' : 'light-theme web-action-calender-modal'
          })
          await modal.present();
          modal.onDidDismiss().then((result) => {
            this.appConstantService.removeAppStateData()
            if (result) {
              this.indexOfLevel = this.appState.get('indexOfLevel')
              let levelCount = this.selectedLevels?.findIndex(item => item.id === level.id)
 
              if (!this.appState.get('levelUpdated') && levelCount != this.selectedLevels[levelCount]?.index) {
                levelCount = levelCount+1
              }
              else {
                levelCount = this.indexOfLevel+1
              }
              
              if (levelCount > 1 || this.appState.get('levelEdit')) {
                if (this.appState.get('levelEdit')) {
                  this.appState.set('levelEdit', undefined)
                }
                if (this.appState.get('isTodoReps') === true) {
                  let currentDay = this.appState.get('lastTodoScreenStep')
                  this.appState.set('isTodoReps', undefined)
                  this.appState.set('lastTodoScreenStep',undefined)
                  if (currentDay === routine.startDay) {
                    this.nextScreen()
                    this.nextScreen()
                  }else{
                    if(this.isMobile) {
                      this.router.navigate(['/content', currentDay], { queryParams: { startFromScreen: 'daily-content-screen-todo' } })
                    }
                    else {
                      setTimeout(()=>{
                        this.modalController.dismiss({ nextHabitUnlockFromToDoScreen: 'nextHabitUnlockFromToDoScreen', currentDay: currentDay})
                        // setTimeout(()=>{
                        //   this.homeUIService.openDailyStepsComponent(DailyStepsContentWebModalV2Component,{currentDay: currentDay,startFromScreen: 'daily-content-screen-todo'},'web-daily-steps-custom-modal')
                        // },550)
                      },550);
                    }
                  }
                  this.appState.set('levelUpdated', undefined)
                } else {
                   this.appState.set('showUpdatedScreens', undefined)
                  let levelSaveData = this.appState.get('levelSaveData')
                  if (levelSaveData) {
                    localStorage.setItem(
                      `Toggle:Day:${levelSaveData.currentDay}:LevelNumber:${levelSaveData.levelId}:true`,
                      'true'
                    )
                    this.appState.set('levelSaveData', undefined)
                  }
                  this.appState.set('updateRoutineData',true)
                  if(this.appState.get('fromTodoWidget')){
                    // this.router.navigate(['/main'])
                    this.appState.set('fromTodoWidget', undefined)
                    setTimeout(() => {
                      this.modalController.dismiss();

                    }, 1100);

                  }else{
                    //this.router.navigate(['/main/commitments'])
                    // this.router.navigate(['/main'])
                    setTimeout(() => {
                      this.modalController.dismiss();
                    }, 550);
                    if (this.appState.get('isNotificationViewed') || this.appState.get('isNotificationViewed')==undefined) {
                      setTimeout(() => {
                        this.homeUIService.openNextComponent(MyCommitmentsComponent, '', 'desktop-todo');
                      }, 800)
                    }
                  }
                }
                this.appState.set('LevelNumber', undefined)
              } else{
                 this.appState.set('showUpdatedScreens', undefined)
                    this.appState.set('levelSaveData', undefined)
                this.appState.set('updateRoutineData', true)
                const check = this.appState.get("isFromEdit");
                //if part logic won't execute as per current flow  
                  if (check) {
                    // this.router.navigate(['/main']);
                    this.modalController.dismiss();
                    if (this.appState.get('isNotificationViewed') || this.appState.get('isNotificationViewed')==undefined) {
                      setTimeout(() => {
                        this.homeUIService.openNextComponent(MyCommitmentsComponent, '', 'desktop-todo');
                      }, 600)
                    }
                  } else {
                    if ( this.selectedCueOption === 'Day(s) & time') {
                      console.log('1.1 :', );
                      this.nextScreen()
                      this.nextScreen()
                    }else{
                      console.log('1.2 :', );
                      this.nextScreen()
                    }
                  }
                if (this.screensIds[this.currentScreenIndex] === "daily-content-screen-commit-routine" && this.commitType === 'dayTime') {
                  if (check) {
                    this.modalController.dismiss();
                    if (this.appState.get('isNotificationViewed') || this.appState.get('isNotificationViewed')==undefined) {
                      setTimeout(() => {
                        this.homeUIService.openNextComponent(MyCommitmentsComponent, '', 'desktop-todo');
                      }, 600)
                    }
                  } else {
                  console.log('nextScreen 2274 :', );
                    this.nextScreen()
                  }
                }
              }
            }
          })
          
          // this.appConstantService.removeAppStateData()
          this.appState.set('isRoutineEdited', false)
          this.appState.set('isLevelCommited',undefined);
        },
        (error) => {
          console.log('error', error)
          this.tostrService.error(this.i18n.t("Server or connection issue. Please check your internet connection."))
        }
      )
  }
  combineDateAndTime(dates: string[], times: string[]): string[] {
    return dates.map((dateStr, index) => {
      const dateObj = new Date(dateStr);

      // Parse time (e.g., "7:30 AM")
      const [time, meridian] = times[index].split(' ');
      let [hours, minutes] = time.split(':').map(Number);

      if (meridian === 'PM' && hours < 12) {
        hours += 12;
      }
      if (meridian === 'AM' && hours === 12) {
        hours = 0;
      }

      dateObj.setHours(hours, minutes, 0, 0);

      return dateObj.toString(); // matches required format
    });
  }

  makeRoutineLater(routine) {
    let scheduledStep = this.appState.get("scheduleDayForCurrentStep");
    mixpanel.track('In Steps-routine later', {'routineId': routine.id, 'routing start step': routine})
    const requestData = {
       step_id:routine.stepId,
        screen_id:routine.screenId,
        screen_content_id:routine.screenContentId,
        is_habit_opted:false,
        habit_group_id: routine.screenId,

    }

    if (!requestData) {
      // this.spinnerService.off();
    } else {
      this.routinev2Service.setKyperHabitOpttIn(requestData).subscribe(
        (response) => {
          if(response.status) {
            this.routineSkipped = true;
          }
          // this.appState.updateAcrossSteps(this.appState.get('DailyStepsData'),'routineInfo', routine.id, {isCompleted: true})
          this.showNotRightNowAlert();
        },
        (error) => {
          this.tostrService.error(this.i18n.t('Something went wrong..! Try Again'))
        }
      )
    }
  }
  async showNotRightNowAlert() {
     const alert = await this.alertController.create({
      // cssClass:'alert-not-committed',
      message: this.i18n.t('You can start building these habits any time via the “Not committed” section of your To-Do List.​'),
      buttons: [
        
        {
          text: this.i18n.t('OK'),
          // role: 'confirm',
          handler: () => {
            
          },
        },
      ],
    });
    
    alert.onWillDismiss().then(() => {
      this.appState.set('IsRepsAppendAfterReoptCommit',undefined)
      this.appState.set('isLevelClosedBeforeCommit',undefined)
      this.skipRoutineScreens();
      let activeStepIndex= this.appState.get('currentLocalStepIndex')
      if (this.allowScreenCount && this.currentDay == this.scheduledDay && this.dailyStepsArray[this.currentOpenedChapter]?.steps[this.activeStepIndex]?.stepStatus != 'Review') {
        if (this.currentScreenIndex < this.screensIds?.length) {
          this.utilService.setScreenData(this.currentScreenIndex, this.currentDay, this.screensIds)
        } else {
          this.utilService.setScreenData(this.currentScreenIndex - 1, this.currentDay, this.screensIds)
        }
      }    
    });
    
    await alert.present();
  }

  skipRoutineScreens(block = false) {
    let scheduledStep = this.appState.get("scheduleDayForCurrentStep");
    let activeStepIndex= this.appState.get('currentActiveStepIndex')
    if (block) { return false }
    this.previousSkippedScreenIndex = this.currentScreenIndex;
    for (let i = 0; i < 6; i++) {
      this.currentScreenIndex++
    }
    if(this.allowScreenCount && this.currentDay ==scheduledStep && this.dailyStepsArray[this.currentOpenedChapter]?.steps[this.activeStepIndex]?.stepStatus!='Review') {
    this.appState.set('currentScreenIndexAfterScreenView', this.currentScreenIndex)
    localStorage.setItem('currentScreenIndexAfterScreenView', JSON.stringify(this.currentScreenIndex));
    }
    if (this.currentScreenIndex >= this.screensIds?.length) {
      return this.lastScreenAction()
      
    }
    this.currentScreenId = this.screensIds[this.currentScreenIndex]
    this.showCurrentScreen()
  }

  async initModal(habit) {
    // this.appState.set('currentDay', this.currentDay)
    const modal = await this.modalCtrl.create({
      component: CompletedReviewModalComponent,
       componentProps: { currentHabit: habit },
      cssClass: this.isMobile?'habit-feedback-modal-css':' web_feedbackForm_modal'
    });

    modal.onDidDismiss().then((modalDataResponse) => {
      if (modalDataResponse !== null) {
        this.modalDataResponse = modalDataResponse.data;
        this.appState.set("isCommented", false)
        this.kyperApiService.getActions(this.currentPath.id)
        this.nextScreen()
      }
    });

    return await modal.present();
  }

  checkLibraryStatus(poll, contentSurvey, document, question, habit, reflection, contentScreens) {
    let savedContentId, habitId, surveyId, pollId, questionId, flag =false, reflectionId;
    let savedLibraryPosts = this.appState.get('savedPosts')

    savedLibraryPosts?.forEach(element => {
     habitId = this.currentPath.filterStepsByContentType('habits',element?.data)?.[0]?.screen?.id ?? null;
      surveyId = this.currentPath.filterStepsByContentType('assessment',element?.data)?.[0]?.screen?.id ?? null;
      pollId = this.currentPath.filterStepsByContentType('poll',element?.data)?.[0]?.screen?.id ?? null;
      questionId = this.currentPath.filterStepsByContentType('social',element?.data)?.[0]?.screen?.id ?? null;
      savedContentId = this.currentPath.filterStepsByContentType('content',element?.data)?.[0]?.screen?.id ?? null;
      // reflectionId = element.reflections[0]?.id

      if (habitId && habitId === this.habit?.screenContentId || savedContentId &&savedContentId ==this.contentScreens[0]?.screenContentId ||
        pollId && pollId === this.poll?.[0]?.screenContentId || surveyId && surveyId === this.contentSurvey?.screenContentId || questionId && questionId === this.question?.screenContentId) {

        // if (element.documents?.length > 0 && element.habits?.length < 1 && element.contentSurveys?.length < 1 &&
        //   element?.polls?.length < 1 && element.questions?.length < 1) {
        //   this.isDocumentOnly = true
        // } else
        if (this.currentPath.filterStepsByContentType('habits',element?.data)?.length > 0 || this.currentPath.filterStepsByContentType('assessment',element?.data)?.length > 0 ||
            this.currentPath.filterStepsByContentType('poll',element?.data)?.length > 0 || this.currentPath.filterStepsByContentType('social',element?.data)?.length > 0
          || this.currentPath.filterStepsByContentType('content',element?.data)?.length > 0) {
          this.isAlreadyPresent = true
          flag =true;

        }
        else if(!flag) {
          this.isAlreadyPresent =undefined
        }
      }
      else if(!flag) {
        this.isAlreadyPresent =undefined
      }
     
    });
    if (savedLibraryPosts?.length < 1) {
      this.isAlreadyPresent = undefined
    }

    let recentSavedPost = this.appState.get('recentSavedStep')
    let recentSavedDocumentId = recentSavedPost?.documents?.[0]?.id
    let recentSavedHabitId = recentSavedPost?.habits?.[0]?.id
    let recentSavedPollId = recentSavedPost?.polls?.length>0?recentSavedPost?.polls?.[0]?.id:null
    let recentSavedQuestionId = recentSavedPost?.questions?.[0]?.id
    let recentSavedSurveyId = recentSavedPost?.contentSurveys?.[0]?.id
    let recentSavedReflectionId = recentSavedPost?.reflections?.[0]?.id

    if (recentSavedDocumentId || recentSavedHabitId || recentSavedPollId || recentSavedSurveyId || recentSavedQuestionId || recentSavedReflectionId) {
      if (recentSavedPost?.documents?.length > 0 && recentSavedPost?.habits?.length < 1 && recentSavedPost?.contentSurveys?.length < 1 &&
        recentSavedPost?.polls?.length < 1 && recentSavedPost?.questions?.length < 1 && recentSavedPost?.reflections?.length < 1) {
        this.isDocumentOnly = true
      } else if (recentSavedPost?.documents?.length > 0 || recentSavedPost?.habits?.length > 0 || recentSavedPost?.contentSurveys?.length > 0 ||
        recentSavedPost?.polls?.length > 0 || recentSavedPost?.questions?.length > 0 || recentSavedPost?.reflections?.length > 0) {
        this.isAlreadyPresent = true
      }
      
    }

    if (this.appState.get('isNewStep')) {
      this.isAlreadyPresent = undefined
      this.isDocumentOnly = undefined
    }

  }

  getCurrentScreenData(contentSurvey, habit, poll, document, question, inoutScreen, routine, pathId, type, reflection) {
    let savedContentId, habitId, surveyId, pollId, questionId, reflectionId;
    let presentPost, presentDocument
    this.savedLibraryPosts = this.appState.get('savedPosts')
    this.savedLibraryPosts?.forEach(element => {
      // savedDocumentId = element.documents[0]?.id
      // habitId = element.habits[0]?.id
      // surveyId = element.contentSurveys[0]?.id
      // pollId = element?.polls?.length > 0 ? element?.polls[0]?.id : null
      // questionId = element.questions[0]?.id
      // reflectionId = element.reflections[0]?.id
      habitId = this.currentPath.filterStepsByContentType('habits',element?.data)?.[0]?.screen?.id ?? null;
      surveyId = this.currentPath.filterStepsByContentType('assessment',element?.data)?.[0]?.screen?.id ?? null;
      pollId = this.currentPath.filterStepsByContentType('poll',element?.data)?.[0]?.screen?.id ?? null;
      questionId = this.currentPath.filterStepsByContentType('social',element?.data)?.[0]?.screen?.id ?? null;
      savedContentId = this.currentPath.filterStepsByContentType('content',element?.data)?.[0]?.screen?.id ?? null;
         if (habitId && habitId === this.habit?.screenContentId || savedContentId &&savedContentId ==this.contentSurvey?.screenContentId ||
        pollId && pollId === this.poll?.[0]?.screenContentId || surveyId && surveyId === this.contentSurvey?.screenContentId || questionId && questionId === this.question?.screenContentId) {
          // if (this.currentPath.filterStepsByContentType('habits',element?.data)?.length > 0 || this.currentPath.filterStepsByContentType('assessment',element?.data)?.length > 0 ||
          //   this.currentPath.filterStepsByContentType('poll',element?.data)?.length > 0 || this.currentPath.filterStepsByContentType('social',element?.data)?.length > 0
          // || this.currentPath.filterStepsByContentType('content',element?.data)?.length > 0) {
          // this.isDocumentOnly = true
          // presentDocument = element
          // } else
           if (this.currentPath.filterStepsByContentType('habits',element?.data)?.length > 0 || this.currentPath.filterStepsByContentType('assessment',element?.data)?.length > 0 ||
            this.currentPath.filterStepsByContentType('poll',element?.data)?.length > 0 || this.currentPath.filterStepsByContentType('social',element?.data)?.length > 0
          || this.currentPath.filterStepsByContentType('content',element?.data)?.length > 0) {
          this.isAlreadyPresent = true
          presentPost = element
        }
      }
      
    });

    let recentSavedPost = this.appState.get('recentSavedStep')

    let recentSavedDocumentId = recentSavedPost?.documents?.[0]?.id
    let recentSavedHabitId = recentSavedPost?.habits?.[0]?.id
    let recentSavedPollId = recentSavedPost?.polls?.length>0?recentSavedPost?.polls?.[0]?.id: null
    let recentSavedQuestionId = recentSavedPost?.questions?.[0]?.id
    let recentSavedSurveyId = recentSavedPost?.contentSurveys?.[0]?.id
    // let recentSavedReflectionId = recentSavedPost?.reflections[0]?.id

    if (recentSavedDocumentId || recentSavedHabitId || recentSavedPollId || recentSavedSurveyId || recentSavedQuestionId) {
      if (recentSavedDocumentId === document?.id || recentSavedHabitId === habit?.id || recentSavedPollId === poll?.id || recentSavedSurveyId === contentSurvey?.id || recentSavedQuestionId === question?.id) {
        if (recentSavedPost?.documents?.length > 0 && recentSavedPost?.habits?.length < 1 && recentSavedPost?.contentSurveys?.length < 1 &&
          recentSavedPost?.polls?.length < 1 && recentSavedPost?.questions?.length < 1) {
          this.isDocumentOnly = true
          presentDocument = recentSavedPost
        } 
        else if ( recentSavedPost?.habits?.length > 0 || recentSavedPost?.contentSurveys?.length > 0 ||
          recentSavedPost?.polls?.length > 0 || recentSavedPost?.questions?.length > 0 ) {
          this.isAlreadyPresent = true
          presentPost = recentSavedPost
        }
       
      }
      
    }

    this.appState.set('isFabClicked', true);    
    this.fabComponents.toArray()?.forEach((ele)=>{
      if(ele?.activated){
        ele?.close();
      }
    })
    this.showFilledBookmark = true;

    //LOGIC to check post is already present or not
    // If present show delete option to user
    // If not present show save option to user
    if (this.isAlreadyPresent || this.isDocumentOnly) {
      //delete this post

      if (type === 'document' && presentPost?.documents?.length > 0 && presentPost?.inoutScreens?.length < 1) {
        this.deletePostAlert(presentPost, 'step')

      } else {
        if (type === 'step' && this.isAlreadyPresent) {
          this.deletePostAlert(presentPost, 'step')

        } else if (type === 'document' && this.isDocumentOnly) {
          this.deletePostAlert(presentDocument, 'document')
        } else {
          if (type === 'step') {
            this.saveStep(contentSurvey, habit, poll, document, question, inoutScreen, routine, reflection, pathId)
          } else if (type === 'document') {
            this.saveDocument(document, pathId)
          }
        }
      }

    } else {
      //create new post
      if (type === 'step') {
        this.saveStep(contentSurvey, habit, poll, document, question, inoutScreen, routine, reflection, pathId)
      } else if (type === 'document') {
        this.saveDocument(document, pathId)
      }
    }
  }

  async deletePostAlert(doc, type) {
    const alert = await this.alertController.create({
      
      subHeader: this.i18n.t("Delete Post"),
      message: this.i18n.t("Do you want to delete this post?"),
      cssClass:this.homeUIService.isDark()?'dark-theme alertBackdrop ':' light-theme alertBackdrop',
      buttons: [
        {
          text: this.i18n.t("Cancel"),
          handler:()=>{
           
          },
          role: 'cancel',
        },
        {
          text: this.i18n.t("Confirm"),
          cssClass: 'custom-alert',
          handler: async () => {
            this.deletePost(doc, type)
          },
        },
      ]  
     });
  
    await alert.present();
  }

  async saveStep(contentSurvey, habit, poll, document, question, inoutScreen, routine, reflection, pathId) {
    this.appState.set('postSaved',true)
    const alert = await this.alertController.create({
      subHeader: this.i18n.t('Save to Library'),
      cssClass:this.homeUIService.isDark()?'dark-theme alertBackdrop':' light-theme alertBackdrop',
       inputs: [
        
         {
           name:'textarea',
           type:'textarea',
           cssClass:'web-textarea',
           placeholder: this.i18n.t('My notes on this step'),
         },
        
       ],
       buttons: [
        {
          text: this.i18n.t('Cancel'),
          handler:()=>{
            this.showFilledBookmark = false;
          },
          role:'Cancel'
        },
         {
           text: this.i18n.t("Save"),
           cssClass: 'custom-alert', 
             handler: (alertData: AlertInput) => {
              localStorage.setItem('journalNote',alertData['textarea']);
              if (alertData['textarea']) {
                let text = localStorage.getItem('journalNote')
                let requestData;
                requestData = {
                  'text': [text],
                  'pathId': pathId,
                  'contentSurveyId': contentSurvey?.id,
                  'habitId': habit?.id,
                  'pollId': poll?.id,
                  'documentId': document?.id,
                  'questionId': question?.id,
                  'inoutScreenId': inoutScreen?.id,
                  'routineInfoId': routine?.id,
                  'screenId': this.savedScreenId,
                  'reflectionId': reflection?.id
                }
                let input = {
                  step_id: this.dailyStepsArray[this.currentOpenedChapter]?.steps[this.activeStepIndex]?.step?.id,
                  note: [text],
                  saved_type: 'step'
                }
        
                //this.spinnerService.on()
                this.libraryService.save(input).subscribe((response) => {
                  this.savedLibraryPosts = this.sessionService.getLibraryPosts()
                  if(this.appState.get('FirstTimeTabCheck')){
                    this.appState.set('tabLabel', 'saved')
                  }
                  this.postToJournal = response?.data; 
                   // this.spinnerService.off()
                  this.appState.set("recentSavedStep", this.postToJournal)
                  this.appState.set("refreshPosts", true)
                  this.appState.set('isNewStep', undefined)
                  this.toasterService.success(this.i18n.t('Step saved.'))
                  this.cdRef.detectChanges()
                  this.isAlreadyPresent = true
        
                },
                  (error) => {
                    this.spinnerService.off()
                    console.log('error :', error);
                  })
              }
               else {
                this.toasterService.warning(this.i18n.t("Please enter valid notes"))
              } 
             }
         },
        ],
     });
     await alert.present();
  }

  async saveDocument(document, pathId) {
    const alert = await this.alertController.create({
      subHeader: this.i18n.t('Save to Library'),
      cssClass:this.homeUIService.isDark()?'dark-theme alertBackdrop':' light-theme alertBackdrop',
       inputs: [
        
         {
           name:'textarea',
           type:'textarea',
           cssClass:'web-textarea',
           placeholder: this.i18n.t('My notes on this step'),
         },
        
       ],
       buttons: [
        {
          text: this.i18n.t('Cancel'),
          handler:()=>{
            this.showFilledBookmark = false;
          },
          role:'Cancel'
        },
         {
           text: this.i18n.t("Save"),
           cssClass: 'custom-alert', 
             handler: (alertData: AlertInput) => {
              localStorage.setItem('journalNote',alertData['textarea']);
              if (alertData['textarea']) {
                  let text = localStorage.getItem('journalNote')
                  let requestData;
                  requestData = {
                    'text': [text],
                    'pathId': pathId,
                    'contentSurveyId': null,
                    'habitId': null,
                    'pollId': null,
                    'documentId': document.id,
                    'questionId': null,
                    'inoutScreenId': null,
                    'routineInfoId': null,
                    'screenId': this.savedScreenId,
                    'reflectionId': null
                  }
          
                  this.spinnerService.on()
                  this.libraryService.save(requestData).subscribe((response) => {
                    console.log("response :", response);
                    this.savedLibraryPosts = this.sessionService.getLibraryPosts();
                    if (this.appState.get("FirstTimeTabCheck")) {
                      this.appState.set("tabLabel", "saved");
                    }
                    this.postToJournal = response?.data;
                    //this.spinnerService.off()
                    this.appState.set("recentSavedStep", this.postToJournal)
                    this.appState.set("refreshPosts", true)
                    this.appState.set('isNewStep', undefined)
                    this.toasterService.success(this.i18n.t('Document saved.'))
                    this.cdRef.detectChanges()
                    this.isDocumentOnly = true
          
                  },
                    (error) => {
                      this.spinnerService.off()
                      console.log('error :', error);
                    })
              }
              else {
                this.toasterService.warning(this.i18n.t("Please enter valid notes"))
               }
             }
             
         },
        ],
     });
     await alert.present();

  }

  deletePost(post: any, type: string) {
    const requestData = {
      id: post?.id
    }
    this.libraryService.deletePost(post?.id,'step').subscribe(
      (response) => {
        this.savedLibraryPosts = this.sessionService.getLibraryPosts()
        this.appState.set('recentSavedStep', undefined)
        console.log('response :', response);
        this.toasterService.success(this.i18n.t('Post Deleted!'))  
        this.checkLibraryStatus(this.poll, this.contentSurvey, this.document, this.question, this.habit, this.reflection,this.contentScreens)
        if (type === 'step') {
          this.isAlreadyPresent = undefined
        } else if (type === 'document') {
          this.isDocumentOnly = undefined
        }
        if(this.appState.get('FirstTimeTabCheck')) {
          if(this.appState.get("savedPostsCount")>0){
            this.appState.set('tabLabel', 'saved')
          } 
          else {
            this.appState.set('tabLabel', 'recommended')
          } 
        }
        this.cdRef.detectChanges()

      },
      (error) => {
        console.log('Error for feedback ', error)
      }
    )
    this.showFilledBookmark = false;
  }

  sendPathCompletionEmail(userId: number) {
    this.utilService.sendEmail(userId).subscribe((response) => {
      console.log("response :", response);
    },
      (error) => {
        console.log('error :', error);
      })
  }

  showKeyboard() {
    if (this.textareaElement && this.screensIds[this.currentScreenIndex] === "daily-content-screen-reflection") {
      this.textareaElement.nativeElement.focus()
      this.utilService.enableHeight(this.textareaContainer, this.isMobile, this.platform, this.keyboard)
    }
  }

  @HostListener('document:click', ['$event'])
  clickout(event) {
      this.contentClick(event)
      let singlePoll = this.appState.get('singlePoll')
      if (singlePoll) {
        this.disableListener?.forEach((element,i) => {
          if(element?.nativeElement.contains(event.target)) {
            this.enableBlur[i] =false;
           this.blurCard(this.enableBlur[i],this.linearScale, this.pathAverage,singlePoll,i);
         }
        });
      }
  }

  getActions(pathId: number) {
    const requestData = {
      'path_id': pathId
    }
    this.kyperApiService.getActionsList(requestData).subscribe((response) => {
      this.todoActions = response?.actions
      // this.todoRoutines = this.homev5Service.removeDuplicates(response.data[0].routine, "screenContentId")
      // this.appState.set('todoRoutines',this.homev5Service.removeDuplicates(response.data[0].routine, "screenContentId"))
      this.appState.set('todoActions',response?.actions)

      // if (!this.isMobile && !this.screensIds?.includes('daily-content-screen-todo') && this.toDos) {
      //   this.addScreen('daily-content-screen-todo')
      // }

    }, (error) => {
      console.log('error :', error);
    })
  }
  getHabits(pathId: number) {
    const requestData = {
      'path_id': pathId
    }
    this.kyperApiService.getHabitsList(requestData).subscribe((response) => {
      this.todoRoutines = this.homev5Service.removeDuplicates(response?.habits, "screenContentId")
      this.appState.set('todoRoutines',this.homev5Service.removeDuplicates(response?.habits, "screenContentId"))
    }, (error) => {
      console.log('error :', error);
    })
  }

  share(event, document) {
    event.stopPropagation()
      try {
        this.downloadFile(document.link)
      } catch (error) {
        console.log('error :', error);
      }
  }

  async downloadFile(url) {
    let fileName, name,transfer;
          let path = null;
    if (url?.includes(".pdf")) {
      name = url.substr(url.lastIndexOf("/") + 1);
      fileName = name.split("?")[0];
      transfer = this.transfer.create();
    
      if (this.platform.is("ios")) {
        path = this.file.documentsDirectory;
      } else {
        path = this.file.dataDirectory;

      }
  
      if (path) {
        transfer.download(url, this.file.dataDirectory + fileName).then((entry) => {
          this.pdfSrc = entry.toURL()
        }, (error) => {
          console.log('download failed: ', error);
        });
      }
     
      else {
        try {
          const response = await fetch(url);
          const blob = await response.blob();
          const objectUrl = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = objectUrl;
          a.download = fileName;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(objectUrl);
        } catch (error) {
          console.error('Error downloading file:', error);
        }
      }
    }
  }
  saveAccountabilityEmails() {
    console.log("accountability emaols", this.onboardLearningComponent?.arrayOfAccountabilyEmails);
    this.onboardLearningComponent?.pushAccountablityEmails(this.currentDay)
  }
}

